import { createSlice, createAsyncThunk, current } from "@reduxjs/toolkit";
import {
	addWeeklyDepletionValuesToGrid,
	applyRowWeeklyBucketsFromQuota,
	apiUrls,
	catchElement,
	depletionPeriodTypeIsFourWeek,
	deriveWeeklyDepletionForSelected,
	elementToBase64,
	getAllCustomerTrustLevels,
	getAllCustomerTypes,
	getAllSKUList,
	getQuotaTableData,
	getRowWeekPercents,
	weekPercentsCurveFromRow,
	prepareCustomers,
	prepareGridData,
	getTimeDepletionGridDefaults,
	gridRowsAllDepletionNone,
	prepareList1,
	prepareList2,
	rowDepletionModelKey,
	applyOverBoxRounderToRow,
	buildSkuRounderDetailsList,
	overBoxRoundValuesFromSkuRounderDetailsList,
	overBoxRounderTypeFromList,
	standardRounderTypeFromList,
	isOverBoxRounderTypeSelected,
	mergeFilteredRowsWithPreRounderBackup,
	syncPreRounderBackupRows,
	getGridRowCompositeKey,
	syncPreRounderBackupFieldsFromRow,
	rowIsWeek4OnlyForExport,
	scenarioExportOmitsRowDepletionType,
	applyWeeklyBucketsExportMask,
	validateCustomers,
} from "./defineUtils";
import { saveAs } from "file-saver";
import dayjs from "dayjs";
import _ from "lodash";
import { fromZonedTime, toZonedTime, formatInTimeZone,format  } from 'date-fns-tz';

const CUSTOMER_PERCENTAGE_THRESHOLD = 0;

const convertToCET = (date) => {
    const timeZone = 'Europe/Paris';
    const utcDate = fromZonedTime(date, timeZone);
    const cetDate = toZonedTime(utcDate, timeZone);
    //return formatInTimeZone(cetDate, timeZone, 'yyyy-MM-dd HH:mm:ssXXX');
    return formatInTimeZone(cetDate, timeZone, "dd/MM/yyyy HH:mm:ss.SSS").slice(0, -4);
  };

export const GetUserCountries = createAsyncThunk(
	"define/GetUserCountries",
	async (obj, { dispatch, getState }) => {
		let reqOptions = {};
		const data = JSON.parse(localStorage.getItem("data"));
		reqOptions.method = obj.method;
		let url = apiUrls.countryListUrl + data.userID;
		return fetch(url, reqOptions).then((r) => {
			return r.json();
		});
	}
);

export const GetScenarioforQuotaDefinition = createAsyncThunk(
	"define/GetScenarioforQuotaDefinition",
	async (obj, { dispatch, getState }) => {
		let reqOptions = {};
		const data = JSON.parse(localStorage.getItem("data"));
		const token = data.token;
		let headers = new Headers();
		// headers.set("Access-Control-Allow-Origin", "*");
		// headers.append("Content-Type", "application/json");
		// headers.append("Accept", "application/json");
		if (token) {
			headers.append("Authorization", `Bearer ${token}`);
		}
		reqOptions.headers = headers;
		reqOptions.method = obj.method;
		let url = apiUrls.GetScenarioforQuotaDefinition + obj.countryId;
		return fetch(url, reqOptions).then((r) => {
			return r.json();
		});
	}
);

export const GetQuotaPeriods = createAsyncThunk(
	"define/GetQuotaPeriods",
	async (obj, { dispatch, getState }) => {
		const { selectedScenario } = getState().define;
		//console.log("currentScenario", selectedScenario);
		if (!selectedScenario.scenarioID) return null;
		let reqOptions = {};
		const data = JSON.parse(localStorage.getItem("data"));
		const token = data.token;
		let headers = new Headers();
		if (token) {
			headers.append("Authorization", `Bearer ${token}`);
		}
		reqOptions.headers = headers;
		reqOptions.method = obj.method;
		let url = apiUrls.GetQuotaPeriods + selectedScenario.scenarioID;
		return fetch(url, reqOptions).then((r) => {
			return r.json();
		});
	}
);
export const GetQuotaPeriodsfromNavigation = createAsyncThunk(
	"define/GetQuotaPeriodsfromNavigation",
	async (obj, { dispatch, getState }) => {
		let reqOptions = {};
		const data = JSON.parse(localStorage.getItem("data"));
		const token = data.token;
		let headers = new Headers();
		if (token) {
			headers.append("Authorization", `Bearer ${token}`);
		}
		reqOptions.headers = headers;
		reqOptions.method = obj.method;
		let url = apiUrls.GetQuotaPeriods + obj.scenarioID;
		return fetch(url, reqOptions).then((r) => {
			return r.json();
		});
	}
);

export const GetQuotaDetails = createAsyncThunk(
	"define/GetQuotaDetails",
	async (obj, { dispatch, getState }) => {
		let reqOptions = {};
		const data = JSON.parse(localStorage.getItem("data"));
		const token = data.token;
		let headers = new Headers();
		if (token) {
			headers.append("Authorization", `Bearer ${token}`);
		}
		reqOptions.headers = headers;
		reqOptions.method = obj.method;
		let url = apiUrls.GetQuotaDetails + obj.queryParams;
		return fetch(url, reqOptions).then((r) => {
			return r.json();
		});
	}
);

export const GetDepletionModels = createAsyncThunk(
	"define/GetDepletionModels",
	async (obj, { dispatch, getState }) => {
		let reqOptions = {};
		const data = JSON.parse(localStorage.getItem("data"));
		const token = data.token;
		let headers = new Headers();
		if (token) {
			headers.append("Authorization", `Bearer ${token}`);
		}
		reqOptions.headers = headers;
		reqOptions.method = obj.method;
		let url = apiUrls.GetDepletionModels;
		return fetch(url, reqOptions).then((r) => {
			return r.json();
		});
	}
);

export const GetDepletionPeriodTypes = createAsyncThunk(
	"define/GetDepletionPeriodTypes",
	async (obj, { dispatch, getState }) => {
		let reqOptions = {};
		const data = JSON.parse(localStorage.getItem("data"));
		const token = data.token;
		let headers = new Headers();
		if (token) {
			headers.append("Authorization", `Bearer ${token}`);
		}
		reqOptions.headers = headers;
		reqOptions.method = obj.method;
		let url = apiUrls.GetDepletionPeriodTypes;
		return fetch(url, reqOptions).then((r) => {
			return r.json();
		});
	}
);

export const GetRounderTypes = createAsyncThunk(
	"define/GetRounderTypes",
	async (obj, { dispatch, getState }) => {
		let reqOptions = {};
		const data = JSON.parse(localStorage.getItem("data"));
		const token = data.token;
		let headers = new Headers();
		if (token) {
			headers.append("Authorization", `Bearer ${token}`);
		}
		reqOptions.headers = headers;
		reqOptions.method = obj.method;
		let url = apiUrls.GetRounderTypes;
		return fetch(url, reqOptions).then((r) => {
			return r.json();
		});
	}
);

export const GetWeeklyDepletionValues = createAsyncThunk(
	"define/GetWeeklyDepletionValues",
	async (obj, { getState }) => {
		const {
			selectedScenario,
			selectedPeriod,
			selectedDepletionPeriodType,
		} = getState().define;
		const dptId =
			selectedDepletionPeriodType?.depletionPeriodTypeID ??
			selectedDepletionPeriodType?.DepletionPeriodTypeID;
		if (
			!selectedScenario?.scenarioID ||
			!selectedPeriod?.startDate ||
			dptId === undefined ||
			dptId === null ||
			dptId === ""
		) {
			return [];
		}
		let reqOptions = {};
		const data = JSON.parse(localStorage.getItem("data"));
		const token = data.token;
		let headers = new Headers();
		if (token) {
			headers.append("Authorization", `Bearer ${token}`);
		}
		reqOptions.headers = headers;
		reqOptions.method = obj.method;
		let url =
			apiUrls.GetWeeklyDepletionValues +
			"?scenarioId=" +
			selectedScenario.scenarioID +
			"&depletionPeriodTypeId=" +
			encodeURIComponent(dptId) +
			"&startDate=" +
			selectedPeriod.startDate;
		const r = await fetch(url, reqOptions);
		if (!r.ok) {
			return [];
		}
		return r.json();
	}
);

export const GetSKUOrPGByScenario = createAsyncThunk(
	"define/GetSKUOrPGByScenario",
	async (obj, { dispatch, getState }) => {
		const { selectedScenario } = getState().define;
		let reqOptions = {};
		const data = JSON.parse(localStorage.getItem("data"));
		const token = data.token;
		let headers = new Headers();
		if (token) {
			headers.append("Authorization", `Bearer ${token}`);
		}
		reqOptions.headers = headers;
		reqOptions.method = obj.method;
		let url = apiUrls.GetSKUOrPGByScenario + selectedScenario.scenarioID;
		return fetch(url, reqOptions).then((r) => {
			return r.json();
		});
	}
);

export const GetQuotaChartData = createAsyncThunk(
	"define/GetQuotaChartData",
	async (obj, { dispatch, getState }) => {
		dispatch(setLoadData());
		const { chartObj } = getState().define;
		let reqOptions = {};
		const data = JSON.parse(localStorage.getItem("data"));
		const token = data.token;
		let headers = new Headers();
		headers.set("Access-Control-Allow-Origin", "*");
		headers.append("Content-Type", "application/json");
		headers.append("Accept", "application/json");
		if (token) {
			headers.append("Authorization", `Bearer ${token}`);
		}
		reqOptions.headers = headers;
		reqOptions.method = obj.method;
		reqOptions.body = JSON.stringify(chartObj);
		let url = apiUrls.GetQuotaChartData;
		return fetch(url, reqOptions).then((r) => {
			return r.json();
		});
	}
);

export const ExportExcel = createAsyncThunk(
	"define/ExportExcel",
	async (obj, { dispatch, getState }) => {
		const {
			selectedCountry,
			selectedScenario,
			selectedPeriod,
			selectedQuota,
			selectedDepletion,
			isWeek4Only,
			depletionModelsList,
			selectedDepletionPeriodType,
		} = getState().define;
		let reqOptions = {};
		const data = JSON.parse(localStorage.getItem("data"));
		const token = data.token;
		let headers = new Headers();
		headers.set("Access-Control-Allow-Origin", "*");
		headers.append("Content-Type", "application/json");
		headers.append("Accept", "application/json");
		if (token) {
			headers.append("Authorization", `Bearer ${token}`);
		}
		reqOptions.headers = headers;
		reqOptions.method = obj.method;
		// console.log(selectedQuota.listQuotaCustomers);
		const omitRowDepletionType = scenarioExportOmitsRowDepletionType(selectedScenario);
		const body = {
			countryId: selectedScenario.countryID,
			countryName: selectedCountry.countryName,
			displayDate: selectedPeriod.displayDate,
			effectiveEndDate: selectedQuota.effectiveEndDate,
			effectiveStartDate: selectedQuota.effectiveStartDate,
			scenarioID: selectedScenario.scenarioID,
			scenarioName: selectedScenario.scenarioName,
			scenarioPeriodType: selectedScenario?.periodType ?? "",
			weeklyDepletion: selectedDepletion.key,
			depletionPeriodDisplay:
				selectedDepletionPeriodType?.depletionPeriodType ??
				"",
			listQuotaCustomers3: selectedQuota.listQuotaCustomers.map((row) => {
				const dmKey = row.depletionModel ?? "";
				const meta = depletionModelsList?.find(
					(m) => String(m.depletionModel ?? "") === String(dmKey)
				);
				const rowOut = {
					customerGroupID: row.customerGroupID,
					customerNumber: row.customerNumber,
					name: row.name,
					initialQuota: row.initialQuota,
					safetyMargin: row.safetyMargin,
					unusedQuota: row.unusedQuota,
					adjustment: row.adjustment,
					quota: row.quota,
					tender: row.tender,
					customerQuotaComments: row.customerQuotaComments,
					skuNumb: row.skuNumb,
					packName: row.packName,
					isWeek4Only: rowIsWeek4OnlyForExport(row, isWeek4Only),
				};
				const maskedWeeks = applyWeeklyBucketsExportMask(dmKey, {
					weekly1: row.weekly1,
					weekly2: row.weekly2,
					weekly3: row.weekly3,
					weekly4: row.weekly4,
					weekly5: row.weekly5,
				});
				rowOut.weekly1 = maskedWeeks.weekly1;
				rowOut.weekly2 = maskedWeeks.weekly2;
				rowOut.weekly3 = maskedWeeks.weekly3;
				rowOut.weekly4 = maskedWeeks.weekly4;
				rowOut.weekly5 = maskedWeeks.weekly5;
				if (!omitRowDepletionType) {
					rowOut.depletionModel = dmKey;
					rowOut.depletionModelName =
						meta?.depletionModelName ??
						meta?.DepletionModelName ??
						"";
				}
				return rowOut;
			}),
		};
		reqOptions.body = JSON.stringify(body);
		let url = apiUrls.ExportExcel;
		return fetch(url, reqOptions).then((r) => {
			return r.blob();
		});
	}
);

export const ImportExcel = createAsyncThunk(
	"define/ImportExcel",
	async (obj, { dispatch, getState }) => {
		const { selectedCountry, selectedScenario, selectedDepletion } =
			getState().define;
		let reqOptions = {};
		const data = JSON.parse(localStorage.getItem("data"));
		const token = data.token;
		let headers = new Headers();
		headers.set("Access-Control-Allow-Origin", "*");
		// headers.append("Content-Type", "application/json");
		headers.append("Accept", "application/json");
		headers.append("Content-Disposition", "multipart/form-data");
		if (token) {
			headers.append("Authorization", `Bearer ${token}`);
		}

		obj.body.append("country", selectedCountry.countryName);
		obj.body.append("scenario", selectedScenario.scenarioName);
		obj.body.append("weeklyDepletion", selectedDepletion.key);

		reqOptions.headers = headers;
		reqOptions.method = obj.method;
		reqOptions.body = obj.body;
		let url = apiUrls.ImportExcel;
		return fetch(url, reqOptions).then((r) => {
			return r.json();
		});
	}
);

export const SaveQuota = createAsyncThunk(
	"define/SaveQuota",
	async (obj, { dispatch, getState }) => {
		const { saveOrSubmitError } = getState().define;

		if (saveOrSubmitError === 0) {
			const { selectedQuota, selectedScenario } = getState().define;
			const quotaPayload = scenarioExportOmitsRowDepletionType(selectedScenario)
				? { ...selectedQuota, depletionPeriodTypeID: null }
				: selectedQuota;
			let reqOptions = {};
			const data = JSON.parse(localStorage.getItem("data"));
			const token = data.token;
			let headers = new Headers();
			headers.set("Access-Control-Allow-Origin", "*");
			headers.append("Content-Type", "application/json");
			headers.append("Accept", "application/json");
			if (token) {
				headers.append("Authorization", `Bearer ${token}`);
			}
			reqOptions.headers = headers;
			reqOptions.method = obj.method;
			reqOptions.body = JSON.stringify(quotaPayload);
			let url = apiUrls.SaveQuota;
			return fetch(url, reqOptions).then((r) => {
				return r.json();
			});
		}
		return "error";
	}
);

export const Upload = createAsyncThunk(
	"define/Upload",
	async (obj, { dispatch, getState }) => {
		const { files } = getState().define;
		const data = JSON.parse(localStorage.getItem("data"));
		const token = data.token;
		const formData = new FormData();
		for (var i = 0; i < files.length; i++) {
			formData.append("files", files[i], files[i].name);
		}
		const url = apiUrls.Upload;
		try {
			const response = await fetch(url, {
				method: "POST",
				headers: {
					Authorization: `Bearer ${token}`,
					Accept: "application/json",
					"Content-Disposition": "multipart/form-data",
				},
				body: formData,
			});
			const jsonData = await response.json();
			return jsonData;
		} catch (error) {
			console.error("Error: ", error);
		}
	}
);
export const SubmitQuota = createAsyncThunk(
	"define/SubmitQuota",
	async (obj, { dispatch, getState }) => {
		const { saveOrSubmitError } = getState().define;

		if (saveOrSubmitError === 0) {
			const { selectedQuota, selectedScenario } = getState().define;
			const quotaPayload = scenarioExportOmitsRowDepletionType(selectedScenario)
				? { ...selectedQuota, depletionPeriodTypeID: null }
				: selectedQuota;
			let reqOptions = {};
			const data = JSON.parse(localStorage.getItem("data"));
			const token = data.token;
			let headers = new Headers();

			headers.set("Access-Control-Allow-Origin", "*");
			headers.append("Content-Type", "application/json");
			headers.append("Accept", "application/json");
			if (token) {
				headers.append("Authorization", `Bearer ${token}`);
			}
			reqOptions.headers = headers;
			reqOptions.method = obj.method;
			reqOptions.body = JSON.stringify(quotaPayload);
			console.log("Define_SubmitQuota_Payload", quotaPayload);
			let url = apiUrls.SubmitQuota;
			return fetch(url, reqOptions).then((r) => {
				return r.json();
			});
		}
		return "error";
	}
);

export const exportFile = createAsyncThunk(
	"define/exportFile",
	async (obj, thunkAPI) => {
		const data = JSON.parse(localStorage.getItem("data"));
		const token = data.token;
		const { isPdf, payload, displayType } = obj;
		const url =
			apiUrls.exportFile + `isPdf=${isPdf}&displayType=${displayType}`;
		try {
			const response = await fetch(url, {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					Authorization: `Bearer ${token}`,
					Accept: "application/json",
				},
				body: JSON.stringify(payload),
			});
			const res = await response.blob();
			const extension = isPdf ? "pdf" : "xlsx";
			const fileName = `DefineFile.${extension}`;
			saveAs(res, fileName);
			return res;
		} catch (error) {
			console.error("Error: ", error);
		}
	}
);

export const DownloadFile = createAsyncThunk(
	"define/downloadfile",
	async (filepath, thunkAPI) => {
		const data = JSON.parse(localStorage.getItem("data"));
		const token = data.token;
		const url = apiUrls.Downloadfile + `fileName=${filepath}`;
		try {
			const response = await fetch(url, {
				method: "GET",
				headers: {
					"Content-Type": "application/json",
					Authorization: `Bearer ${token}`,
					Accept: "application/json",
				},
			});
			const res = await response.blob();
			const fileName = filepath;
			saveAs(res, fileName);
			return res;
		} catch (error) {
			console.error("Error: ", error);
		}
	}
);
const initialState = {
	isLoading: false,
	isSuccess: false,
	isSuccess_Info: false,
	isFailed: false,
	isFailed_Info: "",
	isError: false,
	isError_Info: "",
	countries: [],
	selectedCountry: {},
	scenarioList: [],
	selectedScenario: {},
	quotaPeriods: [],
	selectedPeriod: {},
	selectedDepletion: {},
	depletionModelsList: [],
	depletionPeriodTypesList: [],
	rounderTypesList: [],
	selectedDepletionPeriodType: null,
	selectedQuota: {},
	TotalAdjustment: 0,
	TotalSafetyMargin: 0,
	TotalUnusedQuota: 0,
	ForecastAdjustment:0,
	TotalQuota: 0,
	TotalTender: 0,
	TotalForecast: 0,
	loadQuotaDetails: false,
	custBreakdownTableList: [],
	loadQuotaChart: false,
	chartObj: {},
	quotaChartColumns: [],
	quotaChartData: [],
	quotaChartColors: [],
	quotaChartSeriesData: [],
	quotaChartLabelNames: [],
	hideWeekColumns: true,
	listProduct: [],
	selectedProduct: {},
	selectedCustomers: [],
	multiplier: 0,
	rounder: 0,
	selectedRounderTypeID: "",
	overBoxRoundValues: {},
	preRounderGridDataBackup: [],
	lastAppliedRounderType: null,
	appliedRounderValue: 0,
	appliedOverBoxRoundValues: {},
	loadedRounderSnapshot: null,
	commonSafetyMargin: 0,
	bufferAdjustment: 0,

	gridData: [],
	gridDataFiltered: [],
	gridDataChanged: false,
	exportDataModalOpen: false,
	exportPdf: false,
	filter_customerTypes: [],
	filter_customerTrustLevels: [],
	filter_skuName: [],
	filter_skuNumber: [],
	SKUList: [],
	skuNumberList: [],
	skuNameList: [],
	onSubmitDisabled: false,
	initialForecast: 0,
	revisedQuota: 0,
	quotaCopy: 0,
	forecastType: "",
	weeklyDepletionValuesList: [],
	/** Set by setDepletionPeriodType; consumed on next GetWeeklyDepletionValues fulfill to run applyRowWeeklyBucketsFromQuota. */
	applyWeeklyBucketsOnNextWeeklyDepletionFetch: false,
	onAllocateClick: false,
	persistDepletionTypeOnAllocate: false,
	/** Saved customer-breakdown rows at last Allocate click (for persist-depletion behaviour). */
	allocateCustomerBreakdownSnapshot: null,
	isValueChanged: false,
	files: [],

	selectedRows: [],

	customerTypes: [],
	customerTrustLevels: [],

	searchText: "",
	selectedView: 1,

	saveOrSubmitError: 0,
	files: [],
	filepath: [],
	comments: "",
	isNavigate: false,
	navigatedCountryId: 0,
	navigatedScenarioId: 0,

	showChart: true,
	quotaTableData: null,
	isWeek4Only: false,
  
  includeZeroMs: false,
};

export const RoundTo = (number, roundto) => {
	if (roundto === 0) {
		return Math.round(number);
	}
	return roundto * Math.round(number / roundto);
};

export const RoundToOverBox = (number, roundto) => {
	if (!roundto || roundto === 0) {
		return Math.round(number);
	}
	return roundto * Math.ceil(number / roundto);
};

function applyRoundValueToGrid(state, roundValueOrGetter, roundFn, sourceFiltered) {
	const getRoundValue =
		typeof roundValueOrGetter === "function"
			? roundValueOrGetter
			: () => roundValueOrGetter;

	const gridDataFiltered = sourceFiltered
		? sourceFiltered.map((row) => ({ ...row }))
		: _.cloneDeep(current(state.gridDataFiltered));
	let appliedAny = false;

	for (let i = 0; i < gridDataFiltered.length; i++) {
		const item = gridDataFiltered[i];
		const roundValue = getRoundValue(item);
		if (!roundValue || roundValue <= 0) {
			continue;
		}
		appliedAny = true;
		const dk = rowDepletionModelKey(item);

		if (!dk || dk === "none") {
			if (item.weekly1 !== undefined) {
				if (typeof item.weekly1 === "string") {
					item.weekly1 = parseFloat(item.weekly1);
				}
				const modifiedValue = roundFn(item.weekly1, roundValue);
				item.weekly1 = modifiedValue;
				item.revisedQuota = modifiedValue;
				item.quota = modifiedValue;
				state.TotalQuota += item.quota;
			}
		} else if (dk === "biweekly") {
			if (item.weekly1 !== undefined) {
				if (typeof item.weekly1 === "string") {
					item.weekly1 = parseFloat(item.weekly1);
				}
				item.weekly1 = roundFn(item.weekly1, roundValue);
			}
			if (item.weekly2 !== undefined) {
				if (typeof item.weekly2 === "string") {
					item.weekly2 = parseFloat(item.weekly2);
				}
				const modifiedValue = roundFn(item.weekly2, roundValue);
				item.weekly2 = modifiedValue;
				item.revisedQuota = modifiedValue;
				item.quota = modifiedValue;
				state.TotalQuota += item.quota;
			}
		} else {
			if (item.weekly1 !== undefined) {
				if (typeof item.weekly1 === "string") {
					item.weekly1 = parseFloat(item.weekly1);
				}
				item.weekly1 = roundFn(item.weekly1, roundValue);
			}
			if (item.weekly2 !== undefined) {
				if (typeof item.weekly2 === "string") {
					item.weekly2 = parseFloat(item.weekly2);
				}
				item.weekly2 = roundFn(item.weekly2, roundValue);
			}
			if (item.weekly3 !== undefined) {
				if (typeof item.weekly3 === "string") {
					item.weekly3 = parseFloat(item.weekly3);
				}
				item.weekly3 = roundFn(item.weekly3, roundValue);
			}
			if (item.weekly4 !== undefined) {
				if (typeof item.weekly4 === "string") {
					item.weekly4 = parseFloat(item.weekly4);
				}
				const modifiedValue = roundFn(item.weekly4, roundValue);
				item.weekly4 = modifiedValue;
				if (item.weekly5 === 0) item.revisedQuota = modifiedValue;
			}
			if (state.isWeek4Only) {
				item.weekly5 = 0;
				item.quota = item.weekly4;
				item.revisedQuota = item.weekly4;
				state.TotalQuota += item.quota;
			} else if (item.weekly5 !== undefined) {
				if (typeof item.weekly5 === "string") {
					item.weekly5 = parseFloat(item.weekly5);
				}
				const modifiedValue = roundFn(item.weekly5, roundValue);
				item.weekly5 = modifiedValue;
				item.revisedQuota = modifiedValue;
				item.quota = modifiedValue;
				state.TotalQuota += item.quota;
			}
		}
	}

	if (!appliedAny) {
		return;
	}

	const uniqueKeys = new Map();
	for (const item of gridDataFiltered) {
		const key = `${item.customerID}-${item.customerGroupID}-${item.productGroupID}-${item.skuid}`;
		uniqueKeys.set(key, item);
	}

	const updatedGrid = [];
	for (const item of state.gridData) {
		const key = `${item.customerID}-${item.customerGroupID}-${item.productGroupID}-${item.skuid}`;
		if (uniqueKeys.has(key)) {
			updatedGrid.push(uniqueKeys.get(key));
		} else {
			updatedGrid.push(item);
		}
	}
	state.gridData = updatedGrid;
	state.gridDataFiltered = gridDataFiltered;
}

function applyOverBoxRoundValueToGrid(state) {
	const backup = state.preRounderGridDataBackup;
	const gridDataFiltered = mergeFilteredRowsWithPreRounderBackup(
		state.gridDataFiltered,
		backup
	);
	const isFourWeekPeriod = state.isWeek4Only;
	let appliedAny = false;

	for (let i = 0; i < gridDataFiltered.length; i++) {
		const item = gridDataFiltered[i];
		const skuId = item.skuid ?? item.SKUID;
		const overBoxRoundValue =
			state.overBoxRoundValues?.[skuId] ??
			state.overBoxRoundValues?.[String(skuId)];

		if (!overBoxRoundValue || overBoxRoundValue <= 0) {
			continue;
		}

		if (
			applyOverBoxRounderToRow(item, overBoxRoundValue, isFourWeekPeriod)
		) {
			appliedAny = true;
		}
	}

	if (!appliedAny) {
		return;
	}

	const uniqueKeys = new Map();
	for (const item of gridDataFiltered) {
		const key = `${item.customerID}-${item.customerGroupID}-${item.productGroupID}-${item.skuid}`;
		uniqueKeys.set(key, item);
	}

	const updatedGrid = [];
	for (const item of state.gridData) {
		const key = `${item.customerID}-${item.customerGroupID}-${item.productGroupID}-${item.skuid}`;
		if (uniqueKeys.has(key)) {
			updatedGrid.push(uniqueKeys.get(key));
		} else {
			updatedGrid.push(item);
		}
	}
	state.gridData = updatedGrid;
	state.gridDataFiltered = gridDataFiltered;
}

function syncPreRounderBackupIfNeeded(state, sourceRows) {
	if (state.preRounderGridDataBackup?.length > 0) {
		syncPreRounderBackupRows(state.preRounderGridDataBackup, sourceRows);
	}
}

function restoreGridFromPreRounderBackup(state) {
	if (!state.preRounderGridDataBackup?.length) {
		return false;
	}
	const backup = _.cloneDeep(current(state.preRounderGridDataBackup));
	state.gridData = backup;
	const backupByKey = new Map(
		backup.map((row) => [getGridRowCompositeKey(row), row])
	);
	state.gridDataFiltered = (state.gridDataFiltered ?? []).map((row) => {
		const backupRow = backupByKey.get(getGridRowCompositeKey(row));
		return backupRow ? { ...backupRow } : { ...row };
	});
	return true;
}

function clearAppliedRounderState(state) {
	state.lastAppliedRounderType = null;
	state.appliedRounderValue = 0;
	state.appliedOverBoxRoundValues = {};
}

function setLoadedRounderSnapshot(state, payload) {
	state.loadedRounderSnapshot = {
		rounder:
			payload?.rounder != null && payload?.rounder !== ""
				? Number(payload.rounder)
				: 0,
		rounderTypeID:
			payload?.rounderTypeID != null && payload?.rounderTypeID !== ""
				? Number(payload.rounderTypeID)
				: null,
		skuRounderDetailsList: payload?.skuRounderDetailsList ?? [],
	};
}

function applyRounderFieldsToSelectedQuota(state, rounder, rounderTypeID, skuList) {
	state.selectedQuota.rounder = rounder;
	state.selectedQuota.rounderTypeID = rounderTypeID;
	state.selectedQuota.skuRounderDetailsList = skuList;
}

function syncLoadedRounderSnapshotFromQuota(state, quota) {
	if (!quota) return;
	state.loadedRounderSnapshot = {
		rounder:
			quota.rounder != null && quota.rounder !== ""
				? Number(quota.rounder)
				: 0,
		rounderTypeID:
			quota.rounderTypeID != null && quota.rounderTypeID !== ""
				? Number(quota.rounderTypeID)
				: null,
		skuRounderDetailsList: quota.skuRounderDetailsList ?? [],
	};
}

function hasRounderDetails(source) {
	if (!source) return false;
	const rounder =
		source.rounder != null && source.rounder !== ""
			? Number(source.rounder)
			: 0;
	const skuList = source.skuRounderDetailsList ?? [];
	const hasSkuRounders = skuList.some(
		(item) => Number(item?.rounder ?? item?.Rounder ?? 0) > 0
	);
	return rounder > 0 || hasSkuRounders;
}

function getPersistedRounderSource(state) {
	if (Number(state.selectedQuota?.quotaID) <= 0) {
		return null;
	}
	if (hasRounderDetails(state.loadedRounderSnapshot)) {
		return state.loadedRounderSnapshot;
	}
	if (hasRounderDetails(state.selectedQuota)) {
		return {
			rounder:
				state.selectedQuota.rounder != null &&
				state.selectedQuota.rounder !== ""
					? Number(state.selectedQuota.rounder)
					: 0,
			rounderTypeID:
				state.selectedQuota.rounderTypeID != null &&
				state.selectedQuota.rounderTypeID !== ""
					? Number(state.selectedQuota.rounderTypeID)
					: null,
			skuRounderDetailsList:
				state.selectedQuota.skuRounderDetailsList ?? [],
		};
	}
	return null;
}

function mergeRounderDetailsFromQuota(target, fallback) {
	if (!fallback) return target ?? {};
	const merged = { ...(target ?? {}) };
	if (!hasRounderDetails(target) && hasRounderDetails(fallback)) {
		merged.rounder = fallback.rounder;
		merged.rounderTypeID = fallback.rounderTypeID;
		merged.skuRounderDetailsList = fallback.skuRounderDetailsList ?? [];
	}
	return merged;
}

function resolveSaveSubmitRounderFields(
	state,
	standardRounderType,
	overBoxRounderType
) {
	if (state.lastAppliedRounderType === "overbox") {
		return {
			rounder: 0,
			rounderTypeID:
				overBoxRounderType?.rounderTypeID ??
				state.selectedRounderTypeID ??
				standardRounderType?.rounderTypeID ??
				null,
			skuList: buildSkuRounderDetailsList(state.appliedOverBoxRoundValues),
		};
	}
	if (state.lastAppliedRounderType === "normal") {
		return {
			rounder: state.appliedRounderValue ?? 0,
			rounderTypeID:
				standardRounderType?.rounderTypeID ??
				state.selectedRounderTypeID ??
				null,
			skuList: [],
		};
	}

	const persisted = getPersistedRounderSource(state);
	if (persisted) {
		return {
			rounder: persisted.rounder ?? 0,
			rounderTypeID:
				persisted.rounderTypeID ??
				state.selectedRounderTypeID ??
				standardRounderType?.rounderTypeID ??
				null,
			skuList: persisted.skuRounderDetailsList ?? [],
		};
	}

	return {
		rounder: 0,
		rounderTypeID:
			state.selectedRounderTypeID !== "" &&
			state.selectedRounderTypeID != null
				? Number(state.selectedRounderTypeID)
				: standardRounderType?.rounderTypeID ?? null,
		skuList: [],
	};
}

export const defineSlice = createSlice({
	name: "define",
	initialState,
	reducers: {
		setState: {
			prepare(name, value, options) {
				return {
					payload: {
						name,
						value,
						preRounderBackupSync: options?.preRounderBackupSync ?? null,
					},
				};
			},
			reducer(state, action) {
				const { name, value, preRounderBackupSync } = action.payload;
				state[name] = value;
				if (
					name === "gridData" &&
					state.preRounderGridDataBackup?.length > 0
				) {
					if (
						preRounderBackupSync?.row &&
						preRounderBackupSync?.fields?.length
					) {
						syncPreRounderBackupFieldsFromRow(
							state.preRounderGridDataBackup,
							preRounderBackupSync.row,
							preRounderBackupSync.fields
						);
					} else if (Array.isArray(value)) {
						syncPreRounderBackupRows(
							state.preRounderGridDataBackup,
							value
						);
					}
				}
			},
		},
		setSelectedCountry(state, { payload }) {
			state.selectedCountry = state.countries.filter(
				(v) => v.countryID === parseInt(payload)
			)[0];
		},
		setSelectedScenario(state, { payload }) {
			state.selectedScenario = state.scenarioList.filter(
				(v) => v.scenarioID === parseInt(payload)
			)[0];
			state.hideWeekColumns =
				state.selectedScenario.periodType === "Monthly" ? true : false;
        state.includeZeroMs = state.selectedScenario.zeroMs === 'Y' ? true : false;;
		},
		setSelectedPeriod(state, { payload }) {
			state.selectedPeriod = state.quotaPeriods.filter(
				(v) => v.displayDate === payload
			)[0];
		},
		setForecast(state, { payload }) {
			state.initialForecast = payload === "" ? 0 : parseInt(payload);
		},
		setQuotaCopy(state, { payload }) {
			state.selectedQuota.quotaCopy = payload === "" ? 0 : parseInt(payload);
			state.ForecastAdjustment= parseFloat(state.selectedQuota.quotaCopy) - parseFloat(state.initialForecast);
		},
		setTimeDepletion(state, { payload }) {
			const match = state.depletionModelsList.find(
				(v) => v.depletionModelName === payload
			);
			if (match) {
				state.selectedDepletion = {
					key: match.depletionModel,
					value: match.depletionModelName,
				};
				const patch = {
					depletionModelID: match.depletionModelID,
					depletionModel: match.depletionModel,
				};
				state.gridData = state.gridData.map((row) => ({
					...row,
					...patch,
				}));
				state.gridDataFiltered = state.gridDataFiltered.map((row) => ({
					...row,
					...patch,
				}));
				state.gridDataChanged = true;
				const refList = state.weeklyDepletionValuesList;
				if (refList?.length && state.gridData?.length) {
					const pt = state.selectedDepletionPeriodType;
					state.gridData = addWeeklyDepletionValuesToGrid(
						state.gridData,
						refList,
						pt
					)
					//.map((row) =>
						//applyRowWeeklyBucketsFromQuota(row, pt)
					//);
					state.gridDataFiltered = addWeeklyDepletionValuesToGrid(
						state.gridDataFiltered,
						refList,
						pt
					)
					//.map((row) =>
						//applyRowWeeklyBucketsFromQuota(row, pt)
					//);
				}
				syncPreRounderBackupIfNeeded(state, state.gridData);
			}
		},
		setDepletionPeriodType(state, { payload }) {
			if (payload == null || payload === "") {
				state.selectedDepletionPeriodType = null;
				return;
			}
			const id =
				typeof payload === "number" ? payload : parseInt(payload, 10);
			const match = state.depletionPeriodTypesList.find(
				(v) =>
					String(
						v.depletionPeriodTypeID ?? v.DepletionPeriodTypeID
					) === String(id)
			);
			state.selectedDepletionPeriodType = match ?? null;
			state.applyWeeklyBucketsOnNextWeeklyDepletionFetch = true;
		},
		setSelectProduct(state, { payload }) {
			state.selectedProduct = state.listProduct.filter(
				(v) => v.packGroupOrSKUID === parseInt(payload)
			)[0];
		},
		setRounder(state, { payload }) {
			if (payload === "" || payload === null || payload === undefined) {
				state.rounder = 0;
				return;
			}
			const parsed = parseInt(payload, 10);
			state.rounder = Number.isNaN(parsed) ? NaN : parsed;
		},
		setSelectedRounderTypeID(state, { payload }) {
			state.selectedRounderTypeID =
				payload === "" || payload === null || payload === undefined
					? ""
					: Number(payload);
		},
		setOverBoxRoundValue(state, { payload }) {
			const { skuId, value } = payload;
			const key = String(skuId);
			if (value === "" || value === null || value === undefined) {
				delete state.overBoxRoundValues[key];
			} else {
				const parsed = parseInt(value, 10);
				state.overBoxRoundValues[key] = Number.isNaN(parsed)
					? NaN
					: parsed;
			}
		},
		setSafetyMargin(state, { payload }) {
			state.commonSafetyMargin =
				payload === "" ? "" : payload === "-" ? "-" : parseInt(payload);
		},
		setBufferAdjustment(state, { payload }) {
			state.bufferAdjustment =
				payload === "" ? "" : payload === "-" ? "-" : parseInt(payload);
		},
		setApplySafetyMargin(state) {
			//state.rounder = parseInt(payload);
			//state.commonSafetyMargin =
			//   state.commonSafetyMargin === null ? 0 : state.commonSafetyMargin;

			const gridDataFiltered = _.cloneDeep(current(state.gridDataFiltered));
			// if (
			//    state.commonSafetyMargin !== "" && state.commonSafetyMargin !== null
			// ) {
			//    for (let i = 0; i < gridDataFiltered.length; i++) {
			//       gridDataFiltered[i].safetyMargin = state.commonSafetyMargin;
			//    }
			// }

			let commonSafetyMarginHasValue =
				state.commonSafetyMargin !== "" && state.commonSafetyMargin !== null;

			if (commonSafetyMarginHasValue) {
				for (let i = 0; i < gridDataFiltered.length; i++) {
					let item = gridDataFiltered[i];
					let safetyMargin =
						(item.initialQuota * state.commonSafetyMargin) / 100;
					// if (
					//    state.bufferAdjustment !== "" && state.bufferAdjustment !== null
					// ){
					//    let customerName = item.name?.toLowerCase();
					//    if (item.isBuffer === true || customerName?.includes("buffer")) {
					//       item.adjustment = state.bufferAdjustment;
					//    }
					// }
					let quota = Math.round(
						item.initialQuota + safetyMargin + item.adjustment + item.tender
					);
					if (quota < 0) {
						state.isError = true;
						state.isError_Info =
							"Quota submitted for each Customer/Customer Group cannot be less than Zero";
						continue;
					} else {
						item.quota = quota;
						item.safetyMargin = state.commonSafetyMargin;

						const dk = rowDepletionModelKey(item);
						const wc = weekPercentsCurveFromRow(item);

						if (dk === "none") {
							item.weekly1 = item.quota;
							item.revisedQuota = item.quota;
						} else if (dk === "biweekly") {
							item.weekly1 = Math.round(
								item.quota * wc.week1
							);
							item.weekly2 = item.quota;
							item.weekly3 = 0;
							item.weekly4 = 0;
							item.weekly5 = 0;
							item.revisedQuota = item.weekly2;
						} else if (dk === "depletion_80_20") {
							item.weekly1 = Math.round(item.quota * wc.week1);
							if (item.weekly1 > item.quota) {
								item.weekly1 = item.quota;
							}

							item.weekly2 = Math.round(
								item.quota * wc.week2
							);
							if (item.weekly2 > item.quota) {
								item.weekly2 = item.quota;
							}

							item.weekly3 = Math.round(
								item.quota * wc.week3
							);
							if (item.weekly3 > item.quota) {
								item.weekly3 = item.quota;
							}

							item.weekly4 = Math.round(
								item.quota * wc.week4
							);
							if (item.weekly4 > item.quota) {
								item.weekly4 = item.quota;
							}
							if (state.isWeek4Only) {
								item.weekly5 = 0;
								item.weekly4 = item.quota;
							} else if (item.quota * wc.week5 !== 0) {
								item.weekly5 = item.quota;
							} else {
								item.weekly4 = item.quota;
								item.weekly5 = item.quota;
							}
							item.revisedQuota = item.quota;
						} else {
							item.weekly1 = Math.round(item.quota * wc.week1);
							if (item.weekly1 > item.quota) {
								item.weekly1 = item.quota;
							}

							item.weekly2 = Math.round(item.weekly1 + item.quota * wc.week2);
							if (item.weekly2 > item.quota) {
								item.weekly2 = item.quota;
							}

							item.weekly3 = Math.round(item.weekly2 + item.quota * wc.week3);
							if (item.weekly3 > item.quota) {
								item.weekly3 = item.quota;
							}

							item.weekly4 = Math.round(item.weekly3 + item.quota * wc.week4);
							if (item.weekly4 > item.quota) {
								item.weekly4 = item.quota;
							}
							if (state.isWeek4Only) {
								item.weekly5 = 0;
								item.weekly4 = item.quota;
							} else if (item.quota * wc.week5 !== 0) {
								item.weekly5 = item.quota;
							} else {
								item.weekly4 = item.quota;
								item.weekly5 = item.quota;
							}
							item.revisedQuota = item.quota;
						}
					}
				}

				//const updatedGrid = [];
				// for (let i = 0; i < state.gridData.length; ++i) {
				//    let itemchanged = gridDataFiltered.find(
				//       (obj) =>
				//          obj.customerID === state.gridData[i].customerID &&
				//          obj.customerGroupID ===
				//             state.gridData[i].customerGroupID &&
				//          obj.productGroupID === state.gridData[i].productGroupID &&
				//          obj.skuid === state.gridData[i].skuid
				//    );
				//    if (itemchanged) {
				//       updatedGrid.push(itemchanged);
				//    } else {
				//       updatedGrid.push(state.gridData[i]);
				//    }
				// }
				const uniqueKeys = new Map();
				for (const item of gridDataFiltered) {
					const key = `${item.customerID}-${item.customerGroupID}-${item.productGroupID}-${item.skuid}`;
					uniqueKeys.set(key, item);
				}

				const updatedGrid = [];

				for (const item of state.gridData) {
					const key = `${item.customerID}-${item.customerGroupID}-${item.productGroupID}-${item.skuid}`;
					if (uniqueKeys.has(key)) {
						updatedGrid.push(uniqueKeys.get(key));
					} else {
						updatedGrid.push(item);
					}
				}
				state.gridData = updatedGrid;
				state.gridDataFiltered = gridDataFiltered;
				syncPreRounderBackupIfNeeded(state, updatedGrid);
			}
		},
		setApplyBufferAdjustment(state, { payload }) {
			const gridDataFiltered = _.cloneDeep(current(state.gridDataFiltered));
			if (state.bufferAdjustment !== "" && state.bufferAdjustment !== null) {
				for (let i = 0; i < gridDataFiltered.length; i++) {
					let item = gridDataFiltered[i];
					let safetyMargin = (item.initialQuota * item.safetyMargin) / 100;
					let customerName = item.name?.toLowerCase();
					if (item.isBuffer === true || customerName?.includes("buffer")) {
						let quota = Math.round(
							item.initialQuota + safetyMargin + state.bufferAdjustment
						);
						if (quota < 0) {
							state.isError = true;
							state.isError_Info =
								"Quota submitted for each Customer/Customer Group cannot be less than Zero";
							continue;
						} else {
							item.adjustment = state.bufferAdjustment;
							item.quota = quota;
						}
					} else {
						continue;
					}

					const dk = rowDepletionModelKey(item);
					const wc = weekPercentsCurveFromRow(item);

					if (dk === "none") {
						item.weekly1 = item.quota;
						item.revisedQuota = item.quota;
					} else if (dk === "biweekly") {
						item.weekly1 = Math.round(
							item.quota * wc.week1
						);
						item.weekly2 = item.quota;
						item.weekly3 = 0;
						item.weekly4 = 0;
						item.weekly5 = 0;
						item.revisedQuota = item.weekly2;
					} else if (dk === "depletion_80_20") {
						item.weekly1 = Math.round(item.quota * wc.week1);
						if (item.weekly1 > item.quota) {
							item.weekly1 = item.quota;
						}

						item.weekly2 = Math.round(item.quota * wc.week2);
						if (item.weekly2 > item.quota) {
							item.weekly2 = item.quota;
						}

						item.weekly3 = Math.round(item.quota * wc.week3);
						if (item.weekly3 > item.quota) {
							item.weekly3 = item.quota;
						}

						item.weekly4 = Math.round(item.quota * wc.week4);
						if (item.weekly4 > item.quota) {
							item.weekly4 = item.quota;
						}

						if (state.isWeek4Only) {
							item.weekly5 = 0;
							item.weekly4 = item.quota;
						} else if (item.quota * wc.week5 !== 0) {
							item.weekly5 = item.quota;
						} else {
							item.weekly4 = item.quota;
							item.weekly5 = item.quota;
						}
						item.revisedQuota = item.quota;
					} else {
						item.weekly1 = Math.round(item.quota * wc.week1);
						if (item.weekly1 > item.quota) {
							item.weekly1 = item.quota;
						}

						item.weekly2 = Math.round(item.weekly1 + item.quota * wc.week2);
						if (item.weekly2 > item.quota) {
							item.weekly2 = item.quota;
						}

						item.weekly3 = Math.round(item.weekly2 + item.quota * wc.week3);
						if (item.weekly3 > item.quota) {
							item.weekly3 = item.quota;
						}

						item.weekly4 = Math.round(item.weekly3 + item.quota * wc.week4);
						if (item.weekly4 > item.quota) {
							item.weekly4 = item.quota;
						}

						if (state.isWeek4Only) {
							item.weekly5 = 0;
							item.weekly4 = item.quota;
						} else if (item.quota * wc.week5 !== 0) {
							item.weekly5 = item.quota;
						} else {
							item.weekly4 = item.quota;
							item.weekly5 = item.quota;
						}
						item.revisedQuota = item.quota;
					}
				}
				//const updatedGrid = [];
				// for (let i = 0; i < state.gridData.length; ++i) {
				//    let itemchanged = gridDataFiltered.find(
				//       (obj) =>
				//          obj.customerID === state.gridData[i].customerID &&
				//          obj.customerGroupID ===
				//             state.gridData[i].customerGroupID &&
				//          obj.productGroupID === state.gridData[i].productGroupID &&
				//          obj.skuid === state.gridData[i].skuid
				//    );
				//    if (itemchanged) {
				//       updatedGrid.push(itemchanged);
				//    } else {
				//       updatedGrid.push(state.gridData[i]);
				//    }
				// }
				const uniqueKeys = new Map();
				for (const item of gridDataFiltered) {
					const key = `${item.customerID}-${item.customerGroupID}-${item.productGroupID}-${item.skuid}`;
					uniqueKeys.set(key, item);
				}

				const updatedGrid = [];

				for (const item of state.gridData) {
					const key = `${item.customerID}-${item.customerGroupID}-${item.productGroupID}-${item.skuid}`;
					if (uniqueKeys.has(key)) {
						updatedGrid.push(uniqueKeys.get(key));
					} else {
						updatedGrid.push(item);
					}
				}
				state.gridDataFiltered = gridDataFiltered;
				state.gridData = updatedGrid;
				syncPreRounderBackupIfNeeded(state, updatedGrid);
			}
		},
		setApplyRounder(state, { payload }) {
			state.rounder = state.rounder === null ? 0 : state.rounder;
			if (state.rounder > 0) {
				if (!state.preRounderGridDataBackup?.length) {
					state.preRounderGridDataBackup = _.cloneDeep(current(state.gridData));
				}
				const sourceFiltered = mergeFilteredRowsWithPreRounderBackup(
					state.gridDataFiltered,
					state.preRounderGridDataBackup
				);
				applyRoundValueToGrid(state, state.rounder, RoundTo, sourceFiltered);
				state.lastAppliedRounderType = "normal";
				state.appliedRounderValue = state.rounder;
			} else if (restoreGridFromPreRounderBackup(state)) {
				clearAppliedRounderState(state);
			}
		},
		setApplyOverBoxRounder(state) {
			const hasValues = Object.values(state.overBoxRoundValues || {}).some(
				(value) => value > 0
			);
			if (hasValues) {
				if (!state.preRounderGridDataBackup?.length) {
					state.preRounderGridDataBackup = _.cloneDeep(current(state.gridData));
				}
				applyOverBoxRoundValueToGrid(state);
				state.lastAppliedRounderType = "overbox";
				state.appliedOverBoxRoundValues = {
					...state.overBoxRoundValues,
				};
			} else if (restoreGridFromPreRounderBackup(state)) {
				clearAppliedRounderState(state);
			}
		},
		setTotalValues(state, { payload }) {
			state.TotalAdjustment = 0;
			state.TotalUnusedQuota = 0;
			state.ForecastAdjustment =0;
			state.TotalSafetyMargin = 0;
			state.TotalQuota = 0;
			state.TotalTender = 0;
			for (let i = 0; i < state.gridData.length; i++) {
				let adjustmentHasValue =
					state.gridData[i].adjustment !== undefined &&
					state.gridData[i].adjustment !== "";

				let unusedQuotaHasValue =
					state.gridData[i].unusedQuota !== undefined &&
					state.gridData[i].unusedQuota !== "";

				let tenderHasValue =
					state.gridData[i].tender !== undefined &&
					state.gridData[i].tender !== "";

				if (adjustmentHasValue) {
					state.TotalAdjustment += Math.round(
						parseFloat(state.gridData[i].adjustment)
					);
				}

				if (unusedQuotaHasValue) {
					state.TotalUnusedQuota += parseFloat(state.gridData[i].unusedQuota);
				}

				if (tenderHasValue) {
					state.TotalTender += parseFloat(state.gridData[i].tender);
				}
				let initQuota;
				let quota;
				initQuota =
					state.gridData[i].initialQuota === undefined &&
					state.gridData[i].initialQuota === ""
						? 0
						: state.gridData[i].initialQuota;
				quota =
					state.gridData[i].quota === undefined ||
					state.gridData[i].quota === ""
						? 0
						: state.gridData[i].quota;
				// state.TotalSafetyMargin += Math.round(
				// 	quota - initQuota - parseFloat(state.gridData[i].adjustment)-  parseFloat(state.gridData[i].tender)
				// );

				state.TotalSafetyMargin += Math.round(
					initQuota*(state.gridData[i].safetyMargin/100)
				);



				//console.log("state.gridData[i]",state.gridData[i]);
				//console.log("state.selectedQuota.quotaCopy",state.selectedQuota.quotaCopy);
				//console.log("state.initialForecast",state.initialForecast);
				state.ForecastAdjustment=  parseFloat(state.selectedQuota.quotaCopy) - parseFloat(state.initialForecast);
				//console.log("state.ForecastAdjustment",state.ForecastAdjustment);
				//console.log(quota-initQuota);
				state.TotalQuota += quota;
			}
		},
		setWeekPercent(state, { payload }) {
			state.TotalForecast = 0;
			for (let i = 0; i < state.gridData.length; i++) {
        let initialQuotaCondition = false;
        if (state.includeZeroMs === true) {
          initialQuotaCondition = 
          state.gridData[i].customerPercentageExact <= CUSTOMER_PERCENTAGE_THRESHOLD &&
					state.gridData[i].initialQuota < state.gridData[i].minimumQuota
        }
        else {
          initialQuotaCondition = 
          state.gridData[i].customerPercentageExact > CUSTOMER_PERCENTAGE_THRESHOLD &&
					state.gridData[i].initialQuota < state.gridData[i].minimumQuota
        }
				if (initialQuotaCondition)
        {
          state.gridData[i].initialQuota = state.gridData[i].minimumQuota;
        }
					
				state.TotalForecast += Math.round(state.gridData[i].initialQuota);
				const wc = getRowWeekPercents(
					state.weeklyDepletionValuesList,
					state.selectedDepletionPeriodType,
					state.gridData[i]
				);
				state.gridData[i].weekly1Per = wc.week1;
				state.gridData[i].weekly2Per = wc.week2;
				state.gridData[i].weekly3Per = wc.week3;
				state.gridData[i].weekly4Per = wc.week4;
				state.gridData[i].weekly5Per = wc.week5;
			}
			syncPreRounderBackupIfNeeded(state, state.gridData);
		},
		setWeekPercentDepletion(state, { payload }) {
			state.TotalAdjustment = 0;
			state.TotalUnusedQuota = 0;
			state.ForecastAdjustment = 0;
			state.TotalSafetyMargin = 0;
			state.TotalQuota = 0;
			state.TotalTender = 0;
			let data = _.cloneDeep(current(state.gridData));
			for (let i = 0; i < data.length; i++) {
				// let share = parseFloat(data[i].sharePercentage.toString()).toFixed(
				//    5
				// );

				let sharePercentage = parseFloat(
					data[i].sharePercentage.toString()
				).toFixed(5);
				let initQuota =
					state.selectedQuota.quotaCopy * parseFloat(sharePercentage);
				let roundedInitQuota = Math.round(initQuota);
				let normInitQuota =	roundedInitQuota===0?0:roundedInitQuota;

				data[i].initialQuota = normInitQuota;

				// data[i].initialQuota = Math.round(
				//    state.initialForecast * parseFloat(share)
				// );
				//data[i].initialQuota = Math.round(initQuota);
				// let initialquota = state.initialForecast * parseFloat(share);
				// sharePercentage 

				let initialQuotaCondition = false;
        if (state.includeZeroMs === true) {
          initialQuotaCondition = 
          //data[i].customerPercentageExact <= CUSTOMER_PERCENTAGE_THRESHOLD &&
          data[i].initialQuota < data[i].minimumQuota;
        } else {
          initialQuotaCondition =
          data[i].customerPercentageExact > CUSTOMER_PERCENTAGE_THRESHOLD && data[i].initialQuota < data[i].minimumQuota;
        }
				if (initialQuotaCondition) {
					data[i].initialQuota = data[i].minimumQuota;
				}

				const quotaBeforeWeekSplit = Math.round(
					data[i].initialQuota +
						((data[i].safetyMargin * data[i].initialQuota) / 100 +
							data[i].adjustment +
							data[i].tender)
				);
				data[i].quota = quotaBeforeWeekSplit;

				state.TotalQuota += quotaBeforeWeekSplit;
				state.TotalAdjustment += data[i].adjustment;
				state.TotalUnusedQuota += data[i].unusedQuota;
				// state.TotalSafetyMargin +=
				// 	data[i].quota -
				// 	data[i].initialQuota -
				// 	data[i].adjustment -
				// 	data[i].tender;
					state.TotalSafetyMargin += Math.round(
						data[i].initialQuota*(state.gridData[i].safetyMargin/100)
					);
				state.ForecastAdjustment= state.selectedQuota?.quotaCopy - data[i].initialForecast;

				const dk = rowDepletionModelKey(data[i]);
				const wc = getRowWeekPercents(
					state.weeklyDepletionValuesList,
					state.selectedDepletionPeriodType,
					data[i]
				);

				if (dk === "none") {
					data[i].weekly1 = data[i].quota;
					data[i].weekly2 = 0;
					data[i].weekly3 = 0;
					data[i].weekly4 = 0;
					data[i].weekly5 = 0;
				} else if (dk === "biweekly") {
					data[i].weekly1 = Math.round(
						data[i].quota * wc.week1
					);

					if (data[i].weekly1 > data[i].quota) {
						data[i].weekly1 = data[i].quota;
					}

					data[i].weekly2 = data[i].quota;
					data[i].weekly3 = 0;
					data[i].weekly4 = 0;
					data[i].weekly5 = 0;
				} else if (dk === "depletion_80_20") {
					data[i].weekly1 = Math.round(data[i].quota * wc.week1);
					if (data[i].weekly1 > data[i].quota) {
						data[i].weekly1 = data[i].quota;
					}

					data[i].weekly2 = Math.round(
						data[i].quota * wc.week2
					);
					if (data[i].weekly2 > data[i].quota) {
						data[i].weekly2 = data[i].quota;
					}

					data[i].weekly3 = Math.round(
						data[i].quota * wc.week3
					);
					if (data[i].weekly3 > data[i].quota) {
						data[i].weekly3 = data[i].quota;
					}

					data[i].weekly4 = Math.round(
						data[i].quota * wc.week4
					);
					if (data[i].weekly4 > data[i].quota) {
						data[i].weekly4 = data[i].quota;
					}
					if (state.isWeek4Only) {
						data[i].weekly5 = 0;
						data[i].weekly4 = data[i].quota;
					} else if (data[i].quota * wc.week5 !== 0) {
						data[i].weekly5 = data[i].quota;
					} else {
						data[i].weekly4 = data[i].quota;
						data[i].weekly5 = data[i].quota;
					}
				} else {
					data[i].weekly1 = Math.round(
						data[i].quota * wc.week1
					);
					if (data[i].weekly1 > data[i].quota) {
						data[i].weekly1 = data[i].quota;
					}

					data[i].weekly2 = Math.round(
						data[i].weekly1 + data[i].quota * wc.week2
					);
					if (data[i].weekly2 > data[i].quota) {
						data[i].weekly2 = data[i].quota;
					}

					data[i].weekly3 = Math.round(
						data[i].weekly2 + data[i].quota * wc.week3
					);
					if (data[i].weekly3 > data[i].quota) {
						data[i].weekly3 = data[i].quota;
					}

					data[i].weekly4 = Math.round(
						data[i].weekly3 + data[i].quota * wc.week4
					);
					if (data[i].weekly4 > data[i].quota) {
						data[i].weekly4 = data[i].quota;
					}
					if (state.isWeek4Only) {
						data[i].weekly5 = 0;
						data[i].weekly4 = data[i].quota;
					} else if (data[i].quota * wc.week5 !== 0) {
						data[i].weekly5 = data[i].quota;
					} else {
						data[i].weekly4 = data[i].quota;
						data[i].weekly5 = data[i].quota;
					}
				}

				data[i].weekly1Per = wc.week1;
				data[i].weekly2Per = wc.week2;
				data[i].weekly3Per = wc.week3;
				data[i].weekly4Per = wc.week4;
				data[i].weekly5Per = wc.week5;
			}
			state.gridData = [...data];
			state.gridDataFiltered = [...data];
			state.preRounderGridDataBackup = [];
			state.TotalSafetyMargin = Math.round(state.TotalSafetyMargin);
		},
		setLoadData(state, { payload }) {
			let data = state.gridData;
			let selectedRows = state.selectedRows;
			let customerIds = [];
			let customerGrpIds = [];
			let showTotalForecast = true;
			let totalQuota = 0;
			let initialQuota = 0;
			let skuPGId = state.selectedProduct.packGroupOrSKUID;
			for (let i = 0; i < selectedRows.length; ++i) {
			   const rowID = selectedRows[i];
			   const item = data.find((obj) => obj.id === rowID);
			   if (item) {
				  const obj = {
					 customerid:
						item.customerID === 0
						   ? item.customerGroupID
						   : item.customerID,
					 custype: item.customerID === 0 ? "CG" : "C",
					 skuid: item.skuid === 0 ? item.productGroupID : item.skuid,
					 skutype: item.skuType,
				  };
				  customerGrpIds.push(obj);
				  totalQuota += item.quota;
			   }
			   showTotalForecast = false;
			   initialQuota = state.selectedQuota.quotaCopy;
			}
			if(skuPGId !== 0 && customerGrpIds.length === 0){
			   totalQuota = 0;
			   initialQuota = 0;
			   showTotalForecast = false;
			   const item = data.filter(x=>x.skuid === skuPGId || x.productGroupID === skuPGId);
			   for (let i = 0; i < item.length; ++i) {
				  totalQuota += item[i].quota;
				  initialQuota += item[i].initialQuota;
			   }
			}
			state.chartObj = {
			   scenarioId: state.selectedScenario.scenarioID,
			   startDate: state.selectedPeriod.startDate,
			   endDate: state.selectedPeriod.endDate,
			   isMonthly:
				  state.selectedScenario.periodType === "Monthly" ? true : false,
			   foreCast: showTotalForecast === false? initialQuota : state.selectedQuota.quotaCopy,
			   totalForeCast: showTotalForecast === false? totalQuota : state.TotalQuota,
			   customerIds: customerIds,
			   customerGrpIds: customerGrpIds,
			   skuPGId: skuPGId,
			};
		 },
		setCustomerQuotaWeekValues(state, { payload }) {
			// state.isValueChanged = true;
			let safetyMargin = (payload.initialQuota * payload.safetyMargin) / 100;
			let updatedQuota = Math.round(
				payload.initialQuota + safetyMargin + payload.adjustment
			);
			state.gridData = state.gridData.map((row) => {
				if (row.id === payload.id) {
					return {
						...row,
						["adjustment"]: payload.adjustment,
						["quota"]: updatedQuota,
					};
				}
				return row;
			});
			syncPreRounderBackupIfNeeded(state, state.gridData);
		},
		setQuotaObject(state, { payload }) {
			const data = JSON.parse(localStorage.getItem("data"));
			const standardRounderType = standardRounderTypeFromList(
				state.rounderTypesList
			);
			const overBoxRounderType = overBoxRounderTypeFromList(
				state.rounderTypesList
			);
			const isSaveOrSubmit =
				payload?.method === "saveQuota" ||
				payload?.method === "submitQuota";

			if (isSaveOrSubmit) {
				const rounderFields = resolveSaveSubmitRounderFields(
					state,
					standardRounderType,
					overBoxRounderType
				);
				applyRounderFieldsToSelectedQuota(
					state,
					rounderFields.rounder,
					rounderFields.rounderTypeID,
					rounderFields.skuList
				);
				state.preRounderGridDataBackup = [];
			} else {
				state.selectedQuota.rounder = state.rounder;
				state.selectedQuota.rounderTypeID =
					state.selectedRounderTypeID !== "" &&
					state.selectedRounderTypeID != null
						? Number(state.selectedRounderTypeID)
						: standardRounderType?.rounderTypeID ?? null;
				state.selectedQuota.skuRounderDetailsList =
					buildSkuRounderDetailsList(state.overBoxRoundValues);
			}

			state.selectedQuota.listQuotaCustomers = state.gridData;
			state.selectedQuota.periodDepletionModel = state.selectedDepletion.key;
			const dptId =
				state.selectedDepletionPeriodType?.depletionPeriodTypeID;
			if (dptId !== undefined && dptId !== null && dptId !== "") {
				state.selectedQuota.depletionPeriodTypeID = Number(dptId);
			} else {
				state.selectedQuota.depletionPeriodTypeID = null;
			}
			state.selectedQuota.effectiveStartDate = state.selectedPeriod.startDate;
			state.selectedQuota.effectiveEndDate = state.selectedPeriod.endDate;

			state.selectedQuota.safetyMargin = state.TotalSafetyMargin;

			state.selectedQuota.initialForecast = state.selectedQuota.quotaCopy;

			if (state.selectedScenario.periodType === "Monthly") {
				state.selectedQuota.isWeekly = false;
			} else {
				state.selectedQuota.isWeekly = true;
			}
			let startDate = dayjs(state.selectedPeriod.startDate);
			const endDate = dayjs(state.selectedPeriod.endDate);
			const currentDate = dayjs();

			// if (state.selectedQuota.isWeekly) {
			// 	if (currentDate >= startDate && currentDate <= endDate) {
			// 		startDate = dayjs()
			// 			.set("year", currentDate.year())
			// 			.set("month", currentDate.month())
			// 			.set("date", currentDate.date() + 1);
			// 	}
			// } else {
			// 	if (currentDate.month() === startDate.month()) {
			// 		startDate = dayjs()
			// 			.set("year", currentDate.year())
			// 			.set("month", currentDate.month())
			// 			.set("date", currentDate.date() + 1);
			// 	}
			// }
			// const year = startDate.year();
			// const month = startDate.month() + 1;
			// const date = startDate.date();
			// const outputDate = `${year}-${month < 10 ? "0" + month : month}-${
			// 	date < 10 ? "0" + date : date
			// }T00:00:00`;
			// state.selectedQuota.effectiveStartDate = outputDate;

			state.selectedQuota.countryId = state.selectedCountry.countryID;
			state.selectedQuota.scenarioName = state.selectedScenario.scenarioName;
			state.selectedQuota.countryName = state.selectedCountry.countryName;
			state.selectedQuota.displayDate = state.selectedPeriod.displayDate;
			if (state.selectedQuota.initialForecast === undefined) {
				state.selectedQuota.initialForecast = 0;
			}
			if (
				state.selectedQuota.comments === undefined ||
				state.selectedQuota.comments === null
			) {
				state.selectedQuota.comments = "";
			}
			if (
				state.selectedQuota.rejectionComments === undefined ||
				state.selectedQuota.rejectionComments === null
			) {
				state.selectedQuota.rejectionComments = "";
			}
			if (
				state.selectedQuota.approveComments === undefined ||
				state.selectedQuota.approveComments === null
			) {
				state.selectedQuota.approveComments = "";
			}

			// if (state.selectedDepletion.key !== "None")
			//    state.selectedQuota.isWeekly = true;
			// else state.selectedQuota.isWeekly = false;
      let previousQuotaStatus = state.selectedQuota.quotaStatus;
      // console.log(previousQuotaStatus);
			if (payload?.method === "submitQuota") {
				state.selectedQuota.quotaStatus = "Submitted";
				if (state.selectedQuota.quotaID === 0) {
					state.selectedQuota.sentToSAP = "N";
				}
			} else if (payload?.method !== "excelDownload") {
				if (state.selectedQuota.quotaID === 0) {
					state.selectedQuota.sentToSAP = "N";
					state.selectedQuota.rejectionComments = "";
					state.selectedQuota.approveComments = "";
				}
				state.selectedQuota.quotaStatus = "Draft";
			}
			state.selectedQuota.updatedBy = data.firstName + " " + data.lastName;
			let today = new Date();
			state.selectedQuota.updatedDate = today;

			if (state.comments !== undefined && state.comments.trim() !== "") {
				let cetDt = convertToCET(new Date());
				if (state.comments.indexOf(state.selectedQuota.updatedBy) <= 0)
					state.selectedQuota.comments =
						state.comments +
						" " +
						state.selectedQuota.updatedBy +
						" " +
						cetDt;
						// `${new Date(today).toLocaleDateString("en-UK", {
						// 	day: "2-digit",
						// 	month: "2-digit",
						// 	year: "numeric",
						// 	hour: "2-digit",
						// 	minute: "2-digit",
						// 	second: "2-digit",
						// })}`;
				else state.selectedQuota.comments = state.comments;
			}
			let TotalForecast = 0;
			for (let i = 0; i < state.selectedQuota.listQuotaCustomers.length; i++) {
				if (state.selectedQuota.listQuotaCustomers[i].quota < 0) {
					state.isError = true;
					state.isError_Info =
						"Quota submitted for each Customer/Customer Group cannot be less than Zero";
					return;
				}
				TotalForecast += state.selectedQuota.listQuotaCustomers[i].quota;
			}
			state.selectedQuota.totalForecast = TotalForecast;
			state.selectedQuota.user = data;
			let customers = prepareCustomers(state.gridData, state.gridDataFiltered);
			let result = validateCustomers(
				customers,
				state.selectedDepletion.key,
				state.isWeek4Only
			);

			if (typeof result === "string") {
				state.isError_Info = result;
				state.isError = true;
				state.saveOrSubmitError = 1;
        state.selectedQuota.quotaStatus = previousQuotaStatus;
			} else {
				state.selectedQuota.listQuotaCustomers2 = result;
				state.selectedQuota.files = [];
				state.selectedQuota.filePaths = state.filepath;
				if (payload?.method !== "excelDownload") {
					state.selectedQuota.listQuotaCustomers = [];
				}
			}
		},
		reset(state, { payload }) {
			if (payload === "countryChange") {
				state.selectedScenario = {};
				state.scenarioList = [];
				state.selectedPeriod = {};
				state.quotaPeriods = [];
				state.hideWeekColumns = true;
				state.selectedDepletion = {};
				state.selectedDepletionPeriodType = null;
				state.selectedQuota = {};
				state.loadQuotaDetails = false;
				state.custBreakdownTableList = [];
				state.loadQuotaChart = false;
				state.quotaChartColumns = [];
				state.quotaChartData = [];
				state.quotaChartColors = [];
				state.quotaChartSeriesData = [];
				state.quotaChartLabelNames = [];
				state.TotalAdjustment = 0;
				state.TotalSafetyMargin = 0;
				state.TotalUnusedQuota = 0;
				state.TotalQuota = 0;
				state.TotalForecast = 0;
				state.filter_customerTypes = [];
				state.filter_customerTrustLevels = [];
				state.filter_skuName = [];
				state.filter_skuNumber = [];
				state.isWeek4Only = false;
				state.weeklyDepletionValuesList = [];
			} else if (payload === "scenarioChange") {
				state.selectedPeriod = {};
				state.quotaPeriods = [];
				state.hideWeekColumns = true;
				state.selectedDepletion = {};
				state.selectedDepletionPeriodType = null;
				state.selectedQuota = {};
				state.loadQuotaDetails = false;
				state.custBreakdownTableList = [];
				state.loadQuotaChart = false;
				state.quotaChartColumns = [];
				state.quotaChartData = [];
				state.quotaChartColors = [];
				state.quotaChartSeriesData = [];
				state.quotaChartLabelNames = [];
				state.TotalAdjustment = 0;
				state.TotalSafetyMargin = 0;
				state.TotalUnusedQuota = 0;
				state.TotalQuota = 0;
				state.TotalForecast = 0;
				state.filter_customerTypes = [];
				state.filter_customerTrustLevels = [];
				state.chartObj = {};
				state.listProduct = [];
				state.selectedProduct = {};
				state.selectedCustomers = [];
				state.multiplier = 0;
				state.rounder = 0;
				state.selectedRounderTypeID = "";
				state.overBoxRoundValues = {};
				state.preRounderGridDataBackup = [];
				clearAppliedRounderState(state);
				state.loadedRounderSnapshot = null;
				state.commonSafetyMargin = 0;
				state.bufferAdjustment = 0;
				state.gridData = [];
				state.gridDataFiltered = [];
				state.onSubmitDisabled = false;
				state.initialForecast = 0;
				state.forecastType = "";
				state.weeklyDepletionValuesList = [];
				state.onAllocateClick = false;
				state.isValueChanged = false;
				state.files = [];
				state.selectedRows = [];
				state.customerTypes = [];
				state.customerTrustLevels = [];
				state.searchText = "";
				state.selectedView = 1;
				state.filepath = [];
				state.comments = "";
				state.severity = "";
				state.filter_skuName = [];
				state.filter_skuNumber = [];
				state.isWeek4Only = false;
			} else if (payload === "onRetriveClick") {
				state.quotaChartColumns = [];
				state.quotaChartData = [];
				state.quotaChartColors = [];
				state.quotaChartSeriesData = [];
				state.quotaChartLabelNames = [];
				state.hideWeekColumns = true;
				state.onAllocateClick = false;
				state.isValueChanged = false;
				state.selectedProduct = {};
				state.filter_customerTypes = [];
				state.filter_customerTrustLevels = [];
				state.filter_skuName = [];
				state.filter_skuNumber = [];
				state.searchText = "";
				state.isWeek4Only = false;
				state.persistDepletionTypeOnAllocate = false;
			} 
			else if(payload === "onsubmitQuota"){
				state.quotaChartColumns = [];
				state.quotaChartData = [];
				state.quotaChartColors = [];
				state.quotaChartSeriesData = [];
				state.quotaChartLabelNames = [];
			}
			else if (payload === "onAllocateClick") {
				state.quotaChartColumns = [];
				state.quotaChartData = [];
				state.quotaChartColors = [];
				state.quotaChartSeriesData = [];
				state.quotaChartLabelNames = [];
				{
					const rows =
						state.gridDataFiltered?.length > 0
							? state.gridDataFiltered
							: state.gridData;
					state.hideWeekColumns =
						!rows?.length || gridRowsAllDepletionNone(rows);
				}
				state.onAllocateClick = true;
				state.selectedProduct = state.listProduct.find(
					(x) => x.packGroupOrSKUName === "All"
				);
				state.filter_customerTypes = [];
				state.filter_customerTrustLevels = [];
				state.filter_skuName = [];
				state.filter_skuNumber = [];
				state.searchText = "";
			} else if (payload === "onApplyRounder") {
				state.quotaChartColumns = [];
				state.quotaChartData = [];
				state.quotaChartColors = [];
				state.quotaChartSeriesData = [];
				state.quotaChartLabelNames = [];
				{
					const rows =
						state.gridDataFiltered?.length > 0
							? state.gridDataFiltered
							: state.gridData;
					state.hideWeekColumns =
						!rows?.length || gridRowsAllDepletionNone(rows);
				}
			} else if (payload === "onProductChange") {
				state.quotaChartColumns = [];
				state.quotaChartData = [];
				state.quotaChartColors = [];
				state.quotaChartSeriesData = [];
				state.quotaChartLabelNames = [];
			} else if (payload === "onImportExcel") {
				state.quotaChartColumns = [];
				state.quotaChartData = [];
				state.quotaChartColors = [];
				state.quotaChartSeriesData = [];
				state.quotaChartLabelNames = [];
				state.filter_customerTypes = [];
				state.filter_skuName = [];
				state.filter_skuNumber = [];
				state.filter_customerTrustLevels = [];
				state.searchText = "";
			} else if (payload === "onRefresh") {
				state.countries = [];
				state.selectedCountry = {};
				state.scenarioList = [];
				state.selectedScenario = {};
				state.quotaPeriods = [];
				state.selectedPeriod = {};
				state.selectedDepletion = {};
				state.selectedDepletionPeriodType = null;
				state.selectedQuota = {};
				state.TotalAdjustment = 0;
				state.TotalSafetyMargin = 0;
				state.TotalUnusedQuota = 0;
				state.TotalQuota = 0;
				state.TotalForecast = 0;
				state.loadQuotaDetails = false;
				state.custBreakdownTableList = [];
				state.loadQuotaChart = false;
				state.chartObj = {};
				state.quotaChartColumns = [];
				state.quotaChartData = [];
				state.quotaChartColors = [];
				state.quotaChartSeriesData = [];
				state.quotaChartLabelNames = [];
				state.hideWeekColumns = true;
				state.listProduct = [];
				state.selectedProduct = {};
				state.selectedCustomers = [];
				state.multiplier = 0;
				state.rounder = 0;
				state.selectedRounderTypeID = "";
				state.overBoxRoundValues = {};
				state.preRounderGridDataBackup = [];
				clearAppliedRounderState(state);
				state.loadedRounderSnapshot = null;
				state.commonSafetyMargin = 0;
				state.bufferAdjustment = 0;
				state.gridData = [];
				state.gridDataFiltered = [];
				state.filter_customerTypes = [];
				state.filter_customerTrustLevels = [];
				state.filter_skuName = [];
				state.filter_skuNumber = [];
				state.onSubmitDisabled = false;
				state.initialForecast = 0;
				state.forecastType = "";
				state.weeklyDepletionValuesList = [];
				state.onAllocateClick = false;
				state.isValueChanged = false;
				state.files = [];
				state.selectedRows = [];
				state.customerTypes = [];
				state.customerTrustLevels = [];
				state.searchText = "";
				state.selectedView = 1;
				state.filepath = [];
				state.comments = "";
				state.severity = "";
				state.messageOpen = false;
				state.isWeek4Only = false;
			} else if (payload === "onPeriodChange") {
				state.selectedDepletion = {};
				state.selectedDepletionPeriodType = null;
				state.selectedQuota = {};
				state.TotalAdjustment = 0;
				state.TotalSafetyMargin = 0;
				state.TotalUnusedQuota = 0;
				state.TotalQuota = 0;
				state.TotalForecast = 0;
				state.loadQuotaDetails = false;
				state.custBreakdownTableList = [];
				state.loadQuotaChart = false;
				state.chartObj = {};
				state.quotaChartColumns = [];
				state.quotaChartData = [];
				state.quotaChartColors = [];
				state.quotaChartSeriesData = [];
				state.quotaChartLabelNames = [];
				state.hideWeekColumns = true;
				state.listProduct = [];
				state.selectedProduct = {};
				state.selectedCustomers = [];
				state.multiplier = 0;
				state.rounder = 0;
				state.selectedRounderTypeID = "";
				state.overBoxRoundValues = {};
				state.preRounderGridDataBackup = [];
				clearAppliedRounderState(state);
				state.loadedRounderSnapshot = null;
				state.commonSafetyMargin = 0;
				state.bufferAdjustment = 0;
				state.gridData = [];
				state.gridDataFiltered = [];
				state.filter_customerTypes = [];
				state.filter_customerTrustLevels = [];
				state.filter_skuName = [];
				state.filter_skuNumber = [];
				state.onSubmitDisabled = false;
				state.initialForecast = 0;
				state.forecastType = "";
				state.weeklyDepletionValuesList = [];
				state.onAllocateClick = false;
				state.isValueChanged = false;
				state.files = [];
				state.selectedRows = [];
				state.customerTypes = [];
				state.customerTrustLevels = [];
				state.searchText = "";
				state.selectedView = 1;
				state.filepath = [];
				state.comments = "";
				state.severity = "";
				state.messageOpen = false;
				state.isWeek4Only = false;
			} else if ("onNavigate") {
				state.selectedScenario = state.scenarioList[0];
				state.selectedPeriod = state.quotaPeriods[0];
			}
		},
		navigatedValues(state, { payload }) {
			state.navigatedCountryId = 0;
			state.navigatedScenarioId = 0;
		},
		addFile(state, action) {
			console.log(action.payload);
			const updatedFiles = [...state.files, action.payload];
			console.log(updatedFiles);
			state.files = updatedFiles;
		},
		deleteFile(state, action) {
			const { name, size } = action.payload;
			const updatedFiles = state.files.filter((file) => file.name !== name);
			state.files = updatedFiles;
		},
		deleteExistingFile(state, action) {
			const { filePath } = action.payload;
			const updatedFiles = state.selectedQuota?.listQuotaFiles.filter(
				(file) => file.filePath !== filePath
			);
			state.selectedQuota.listQuotaFiles = updatedFiles;
		},
		clearStatus(state, { payload }) {
			state.isSuccess = false;
			state.isSuccess_Info = false;
			state.isFailed = false;
			state.isFailed_Info = "";
			state.isError = false;
			state.isError_Info = "";
		},
	},
	extraReducers: (builder) => {
		builder
			.addCase(GetUserCountries.pending, (state, action) => {})
			.addCase(GetUserCountries.fulfilled, (state, { payload }) => {
				state.countries = payload;
				// console.log("selectedCountry", state.selectedCountry);
				if (
					state.navigatedCountryId !== undefined &&
					state.navigatedCountryId !== null &&
					state.navigatedCountryId > 0
				) {
					//state.countryID = state.navigatedCountryId;
					let idx = state.countries.findIndex(
						(country) => country.countryID === state.navigatedCountryId
					);
					state.selectedCountry = state.countries[idx];
				}
			})
			.addCase(GetUserCountries.rejected, (state, action) => {
				console.log("Error from GetUserCountries", action.error.message);
			})

			.addCase(GetScenarioforQuotaDefinition.pending, (state, action) => {
				state.isLoading = true;
			})
			.addCase(
				GetScenarioforQuotaDefinition.fulfilled,
				(state, { payload }) => {
					state.isLoading = false;
					if (payload !== null && payload.length > 0) {
						state.scenarioList = payload;
						if (
							state.navigatedScenarioId !== undefined &&
							state.navigatedScenarioId > 0
						) {
							state.selectedScenario = state.scenarioList.find(
								(scenario) => scenario.scenarioID === state.navigatedScenarioId
							);
						} else {
							state.selectedScenario = state.scenarioList[0];
						}
					} else {
						state.isFailed = true;
						state.isFailed_Info =
							"No Scenario's available for the selected country";
					}
				}
			)
			.addCase(GetScenarioforQuotaDefinition.rejected, (state, action) => {
				state.isLoading = false;
				console.log(
					"Error from GetScenarioforQuotaDefinition",
					action.error.message
				);
			})

			.addCase(GetQuotaPeriods.pending, (state, action) => {
				state.isLoading = true;
			})

			.addCase(GetQuotaPeriods.fulfilled, (state, { payload }) => {
				state.isLoading = false;
				if (state.selectedScenario.scenarioID) {
					if (payload !== null && payload?.length > 0) {
						state.quotaPeriods = payload;
						state.selectedPeriod = state.quotaPeriods[0];
					} else {
						state.isFailed = true;
						state.isFailed_Info =
							"No QuotaPeriods available for the selected scenario";
					}
				}
			})

			.addCase(GetQuotaPeriods.rejected, (state, action) => {
				state.isLoading = false;
				console.log("Error from GetQuotaPeriods", action.error.message);
			})

			.addCase(GetQuotaPeriodsfromNavigation.pending, (state, action) => {
				state.isLoading = true;
			})

			.addCase(
				GetQuotaPeriodsfromNavigation.fulfilled,
				(state, { payload }) => {
					state.isLoading = false;
					if (payload !== null && payload.length > 0) {
						state.quotaPeriods = payload;
						state.selectedPeriod = state.quotaPeriods[0];
					} else {
						state.isFailed = true;
						state.isFailed_Info =
							"No QuotaPeriods available for the selected scenario";
					}
				}
			)

			.addCase(GetQuotaPeriodsfromNavigation.rejected, (state, action) => {
				state.isLoading = false;
				console.log("Error from GetQuotaPeriods", action.error.message);
			})

			.addCase(GetDepletionModels.fulfilled, (state, { payload }) => {
				if (payload != null && Array.isArray(payload)) {
					state.depletionModelsList = payload.map((p) => ({
						depletionModelID: p.depletionModelID,
						depletionModelName: p.depletionModelName,
						depletionModel:
							p.depletionModel,
					}));
					const dm = state.depletionModelsList.find(
						(m) => m.depletionModel === state.selectedDepletion?.key
					);
					if (dm) {
						state.selectedDepletion = {
							key: dm.depletionModel,
							value: dm.depletionModelName,
						};
					}
					const defs = getTimeDepletionGridDefaults(
						state.selectedDepletion,
						state.depletionModelsList
					);
					if (
						defs &&
						state.gridData &&
						state.gridData.length > 0
					) {
						const patchRow = (row) =>
							row.depletionModelID !== undefined &&
							row.depletionModelID !== null &&
							row.depletionModelID !== ""
								? row
								: { ...row, ...defs };
						state.gridData = state.gridData.map(patchRow);
						state.gridDataFiltered =
							state.gridDataFiltered.map(patchRow);
						syncPreRounderBackupIfNeeded(state, state.gridData);
					}
				}
			})
			.addCase(GetDepletionModels.rejected, (state, action) => {
				console.log("Error from GetDepletionModels", action.error.message);
			})

			.addCase(GetDepletionPeriodTypes.fulfilled, (state, { payload }) => {
				if (payload != null && Array.isArray(payload)) {
					const list = payload.map((p) => ({
						depletionPeriodTypeID:
							p.depletionPeriodTypeID,
						depletionPeriodType:
							p.depletionPeriodType,
						depletionPeriodTypeName:
							p.depletionPeriodTypeName,
					}));
					state.depletionPeriodTypesList = list;
					state.selectedDepletionPeriodType =
						list.length > 0 ? list[0] : null;
				}
			})
			.addCase(GetDepletionPeriodTypes.rejected, (state, action) => {
				console.log(
					"Error from GetDepletionPeriodTypes",
					action.error.message
				);
			})

			.addCase(GetRounderTypes.fulfilled, (state, { payload }) => {
				if (payload != null && Array.isArray(payload)) {
					state.rounderTypesList = payload.map((p) => ({
						rounderTypeID: p.rounderTypeID,
						rounderType: p.rounderType,
					}));
					if (
						state.selectedRounderTypeID === "" &&
						state.rounderTypesList.length > 0
					) {
						const standardType = standardRounderTypeFromList(
							state.rounderTypesList
						);
						state.selectedRounderTypeID =
							standardType?.rounderTypeID ?? "";
					}
				}
			})
			.addCase(GetRounderTypes.rejected, (state, action) => {
				console.log("Error from GetRounderTypes", action.error.message);
			})

			.addCase(GetWeeklyDepletionValues.pending, (state, action) => {
				state.isLoading = true;
			})

			.addCase(GetWeeklyDepletionValues.fulfilled, (state, action) => {
				const { payload } = action;
				const applyBucketsToGrid =
					state.applyWeeklyBucketsOnNextWeeklyDepletionFetch === true;
				state.applyWeeklyBucketsOnNextWeeklyDepletionFetch = false;
				state.isLoading = false;
				const raw = payload;
				const list = Array.isArray(raw)
					? raw
					: raw && typeof raw === "object"
						? [raw]
						: [];
				state.weeklyDepletionValuesList = list;
				state.hideWeekColumns = false;
				const dk = String(state.selectedDepletion?.key ?? "").toLowerCase();
				const pt = state.selectedDepletionPeriodType;
				state.isWeek4Only = depletionPeriodTypeIsFourWeek(pt);

				if (state.gridData && state.gridData.length > 0) {
					const pt = state.selectedDepletionPeriodType;
					let gd = addWeeklyDepletionValuesToGrid(
						state.gridData,
						list,
						pt
					);
					let gdf = addWeeklyDepletionValuesToGrid(
						state.gridDataFiltered,
						list,
						pt
					);
					if (applyBucketsToGrid) {
						gd = gd.map((row) =>
							applyRowWeeklyBucketsFromQuota(row, pt)
						);
						gdf = gdf.map((row) =>
							applyRowWeeklyBucketsFromQuota(row, pt)
						);
					}
					state.gridData = gd;
					state.gridDataFiltered = gdf;
					syncPreRounderBackupIfNeeded(state, state.gridData);
				}
			})

			.addCase(GetWeeklyDepletionValues.rejected, (state, action) => {
				state.isLoading = false;
				state.applyWeeklyBucketsOnNextWeeklyDepletionFetch = false;
				console.log(
					"Error from GetWeeklyDepletionValues",
					action.error.message
				);
			})

			.addCase(GetSKUOrPGByScenario.pending, (state, action) => {
				state.isLoading = true;
			})

			.addCase(GetSKUOrPGByScenario.fulfilled, (state, { payload }) => {
				state.isLoading = false;
				if (payload !== null && payload.length > 0) {
					state.listProduct = payload.sort(
						(a, b) => a.packGroupOrSKUID - b.packGroupOrSKUID
					);
					state.selectedProduct = payload.find(
						(x) => x.packGroupOrSKUName === "All"
					);
				}
			})

			.addCase(GetSKUOrPGByScenario.rejected, (state, action) => {
				state.isLoading = false;
				console.log("Error from GetSKUOrPGByScenario", action.error.message);
			})

			.addCase(GetQuotaDetails.pending, (state, action) => {
				state.isLoading = true;
			})
			.addCase(GetQuotaDetails.fulfilled, (state, { payload }) => {
				state.isLoading = false;
				if (payload !== null) {
					if (!state.onAllocateClick) {
						state.overBoxRoundValues =
							overBoxRoundValuesFromSkuRounderDetailsList(
								payload?.skuRounderDetailsList
							);
						setLoadedRounderSnapshot(state, payload);
						clearAppliedRounderState(state);
						if (
							payload?.rounderTypeID != null &&
							payload?.rounderTypeID !== ""
						) {
							state.selectedRounderTypeID = Number(
								payload.rounderTypeID
							);
						} else {
							const hasOverBoxValues = Object.values(
								state.overBoxRoundValues || {}
							).some(
								(value) =>
									value != null &&
									value !== "" &&
									Number(value) > 0
							);
							const overBoxType = overBoxRounderTypeFromList(
								state.rounderTypesList
							);
							const standardType = standardRounderTypeFromList(
								state.rounderTypesList
							);
							state.selectedRounderTypeID = hasOverBoxValues
								? overBoxType?.rounderTypeID ??
									standardType?.rounderTypeID ??
									""
								: standardType?.rounderTypeID ?? "";
						}
						if (
							payload?.rounder != null &&
							payload?.rounder !== ""
						) {
							state.rounder = Number(payload.rounder);
						}
					}
					const data = JSON.parse(localStorage.getItem("data"));
					if (payload.listQuotaCustomers.length <= 0) {
						state.onSubmitDisabled = true;
					} else if (data.isAdmin === true) {
						state.onSubmitDisabled = false;
					} else {
						if (
							payload.quotaStatus === "Submitted" ||
							payload.quotaStatus === "Approved" ||
							payload.quotaStatus === "Draft" ||
							payload.quotaStatus === "Rejected" ||
							payload.quotaStatus === "Locally Approved"
						) {
							state.onSubmitDisabled = payload.isSubmitLocked;
						}
					}
					if (!state.onAllocateClick) {
						state.allocateCustomerBreakdownSnapshot = null;
						const models = state.depletionModelsList;
						const typesList = state.depletionPeriodTypesList || [];

						const isEmptyStr = (v) =>
							v === undefined ||
							v === null ||
							String(v).trim() === "";

						const resolvePeriodTypeRow = (hint) => {
							if (!typesList.length || isEmptyStr(hint)) return null;
							const norm = String(hint).trim().toLowerCase();
							return (
								typesList.find((v) => {
									const t1 = String(
										v.depletionPeriodType ?? ""
									)
										.trim()
										.toLowerCase();
									const t2 = String(
										v.depletionPeriodTypeName ?? ""
									)
										.trim()
										.toLowerCase();
									return t1 === norm || t2 === norm;
								}) ?? null
							);
						};

						const fiveWeekStandardRow =
							typesList.find((v) => {
								const t = String(
									v.depletionPeriodType ?? ""
								)
									.trim()
									.toLowerCase();
								return (
									t.includes("5-week") && t.includes("standard")
								);
							}) ??
							typesList[0] ??
							null;

						if (state.selectedScenario.periodType === "Weekly") {
							if (models.length > 0) {
								const noneModel =
									models.find((p) => p.depletionModel === "None") ||
									models[0];
								state.selectedDepletion = {
									key: noneModel.depletionModel,
									value: noneModel.depletionModelName,
								};
							} else {
								state.selectedDepletion = {
									key: "None",
									value: "None",
								};
							}
							state.selectedDepletionPeriodType =
								fiveWeekStandardRow;
						} else {
							const rawPd =
								payload.periodDepletionModel;
							const prevPd =
								payload.previousPeriodDepletionModel;
							const effectiveDmKey = isEmptyStr(rawPd)
								? prevPd
								: rawPd;

							const currentPtId =
								payload.depletionPeriodTypeID;
							const currentPtLabel = payload.depletionPeriodType;
							const prevPtRaw =
								payload.previousDepletionPeriodType;

							const currentPtPresent =
								!isEmptyStr(currentPtLabel) ||
								(currentPtId != null &&
									currentPtId !== "" &&
									Number(currentPtId) > 0);

							const ptHint = currentPtPresent
								? !isEmptyStr(currentPtLabel)
									? currentPtLabel
									: currentPtId
								: prevPtRaw;

							state.selectedDepletionPeriodType =
								resolvePeriodTypeRow(ptHint);

							const headerDmName = isEmptyStr(rawPd)
								? null
								: payload.periodDepletionModelName;

							if (models.length > 0) {
								const wObj =
									models.find(
										(p) =>
											p.depletionModel === effectiveDmKey ||
											String(p.depletionModel ?? "")
												.toLowerCase() ===
												String(effectiveDmKey ?? "")
													.toLowerCase()
									) ||
									(headerDmName
										? models.find(
												(p) =>
													String(
														p.depletionModelName ?? ""
													)
														.trim()
														.toLowerCase() ===
													String(headerDmName)
														.trim()
														.toLowerCase()
											)
										: null) ||
									models.find(
										(p) => p.depletionModel === "None"
									) ||
									models[0];
								state.selectedDepletion = {
									key: wObj.depletionModel,
									value: wObj.depletionModelName,
								};
							} else {
								const key =
									effectiveDmKey !== undefined &&
									effectiveDmKey !== null &&
									String(effectiveDmKey).trim() !== ""
										? effectiveDmKey
										: "None";
								state.selectedDepletion = {
									key,
									value: key,
								};
							}
						}

						const dk = String(
							state.selectedDepletion?.key ?? ""
						).toLowerCase();
						const selWk = deriveWeeklyDepletionForSelected(
							state.weeklyDepletionValuesList,
							state.selectedDepletion,
							state.selectedDepletionPeriodType
						);

						state.initialForecast = Math.round(payload.initialForecast);
						state.quotaCopy = Math.round(payload.quotaCopy);
						state.forecastType = payload.forecastType;
						state.selectedQuota = payload;
						const tdDefaults = getTimeDepletionGridDefaults(
							state.selectedDepletion,
							state.depletionModelsList
						);
						const table = prepareGridData(
							payload?.listQuotaCustomers,
							payload?.initialForecast,
							tdDefaults,
							{ depletionModelsList: state.depletionModelsList }
						);
						state.comments = payload?.comments.split('<br/>').join('\n');
						state.revisedQuota = payload?.revisedQuota;
						state.gridData = table;
						state.gridDataFiltered = table.slice();
						state.preRounderGridDataBackup = [];
						state.customerTypes = getAllCustomerTypes(state.gridDataFiltered);
						state.customerTrustLevels = getAllCustomerTrustLevels(
							state.gridDataFiltered
						);
						state.SKUList = getAllSKUList(state.gridDataFiltered);
						const skuNumbers = state.SKUList.map((item) => item.skuNumber);
						state.skuNumberList = [...new Set(skuNumbers)];
						const skuNames = state.SKUList.map((item) => item.skuName);
						state.skuNameList = [...new Set(skuNames)];
					} else {
						state.custBreakdownTableList = payload?.listQuotaCustomers;
						// on allocate click following lines was not getting executed
						const tdDefaultsAllocate = getTimeDepletionGridDefaults(
							state.selectedDepletion,
							state.depletionModelsList
						);
						const forceAllocDepletionToQuota =
							!state.persistDepletionTypeOnAllocate;
						const persistSnap =
							state.persistDepletionTypeOnAllocate &&
							Array.isArray(state.allocateCustomerBreakdownSnapshot) &&
							state.allocateCustomerBreakdownSnapshot.length > 0
								? state.allocateCustomerBreakdownSnapshot
								: null;
						const table = prepareGridData(
							payload?.listQuotaCustomers,
							payload?.initialForecast,
							tdDefaultsAllocate,
							{
								forceTimeDepletionOnly: forceAllocDepletionToQuota,
								depletionModelsList: state.depletionModelsList,
								persistAllocateBreakdownSnapshot: persistSnap,
							}
						);
						state.comments = payload?.comments.split('<br/>').join('\n');
						state.revisedQuota = payload?.revisedQuota;
						state.gridData = table;
						state.gridDataFiltered = table.slice();
						state.preRounderGridDataBackup = [];
						state.customerTypes = getAllCustomerTypes(state.gridDataFiltered);
						state.customerTrustLevels = getAllCustomerTrustLevels(
							state.gridDataFiltered
						);
						state.SKUList = getAllSKUList(state.gridDataFiltered);
					}
					state.loadQuotaDetails = true;
				}
			})
			.addCase(GetQuotaDetails.rejected, (state, action) => {
				state.isLoading = false;
				console.log("Error from GetQuotaDetails", action.error.message);
			})

			.addCase(GetQuotaChartData.pending, (state, action) => {
				state.isLoading = true;
			})

			.addCase(GetQuotaChartData.fulfilled, (state, { payload }) => {
				state.isLoading = false;
				if (payload !== null) {
					console.log("GetQuotaChartData", payload);
					state.quotaChartColumns = payload.columns;
					state.quotaChartData = payload.data;
					state.quotaChartColors = payload.colors;
					let data = [];
					for (let i = 0; i < state.quotaChartData.length; i++) {
						let s = state.quotaChartData[i][0].split(",");
						for (let k = 0; k < s.length; k++) {
							if (k > 0) {
								if (!isNaN(s[k])) s[k] = Number(s[k]);
								if (s[k] === "null") {
									s[k] = null;
								} else if (i < state.quotaChartData.length - 1 && s[k] === 0) {
									s[k] = null;
								}
							}
						}
						data.push(s);
					}
					let labelNames = [];
					data.forEach((item) => {
						labelNames.push(item[0]);
					});
					state.quotaChartLabelNames = labelNames;

					let seriesDatas = [];
					for (let i = 1; i < state.quotaChartColumns.length; i++) {
						let seriesData = [];
						data.forEach((item) => {
							seriesData.push(item[i]);
						});

						seriesDatas.push({
							name: state.quotaChartColumns[i],
							data: seriesData,
						});
					}
					state.quotaChartSeriesData = seriesDatas;
					const quotaTableData = getQuotaTableData(
						payload.columns,
						payload.data
					);
					state.quotaTableData = quotaTableData;
					state.loadQuotaChart = true;
				}
			})

			.addCase(GetQuotaChartData.rejected, (state, action) => {
				state.isLoading = false;
				console.log("Error from GetQuotaChartData", action.error.message);
			})

			.addCase(ExportExcel.pending, (state, action) => {
				state.isLoading = true;
			})

			.addCase(ExportExcel.fulfilled, (state, { payload }) => {
				state.isLoading = false;
				if (payload !== null) {
					saveAs(
						payload,
						state.selectedCountry.countryName +
							"_" +
							state.selectedScenario.scenarioName +
							"_Import.xlsx"
					);
				} else {
					state.isFailed = true;
					state.isFailed_Info =
						"Export of Quota file failed. Please try after some time!";
				}
			})
			.addCase(ExportExcel.rejected, (state, action) => {
				state.isLoading = false;
				console.log("Error from ExportExcel", action.error.message);
			})

			.addCase(ImportExcel.pending, (state, action) => {
				state.isLoading = true;
			})
			.addCase(ImportExcel.fulfilled, (state, { payload }) => {
				state.isLoading = false;
				if (payload !== null) {
					let customers = [];
					customers = payload?.listQuotaCustomers;
					if (customers === undefined) {
						state.isFailed = true;
						state.isFailed_Info =
							"Error occured while importing file. Please try again with correct file.";
						return;
					}
					if (customers.length === 0) {
						state.isFailed = true;
						state.isFailed_Info = "No record to import for file";
						return;
					}
					const gridDataMap = new Map(
						state.gridData.map((item) => [
							`${
								item.customerNumber !== "" &&
								item.customerNumber !== undefined &&
								item.customerNumber !== null
									? item.customerNumber
									: item.customerGroupName
							}_${item.skuNumb}`,
							item,
						])
					);

					const normalizeDepletionModelId = (id) => {
						if (
							id === undefined ||
							id === null ||
							id === ""
						) {
							return null;
						}
						return String(id);
					};
					const matchDepletionModelByImportName = (
						importedNameTrimmed
					) => {
						if (
							!importedNameTrimmed ||
							!state.depletionModelsList?.length
						) {
							return null;
						}
						const low = importedNameTrimmed.toLowerCase();
						return (
							state.depletionModelsList.find(
								(x) =>
									String(
										x.depletionModelName ??
											x.DepletionModelName ??
											""
									)
										.trim()
										.toLowerCase() === low
							) ?? null
						);
					};

					for (const customer of customers) {
						const customerKey = `${
							customer.customerNumber !== null
								? customer.customerNumber
								: customer.customerName
						}_${customer.skuNumb}`;
						const item = gridDataMap.get(customerKey);
						if (!item) continue;

						const importedName = String(
							customer.depletionModelName ??
								customer.DepletionModelName ??
								""
						).trim();
						if (!importedName) continue;

						const matchedImportModel =
							matchDepletionModelByImportName(importedName);
						if (!matchedImportModel) {
							state.isError = true;
							state.isError_Info = `Unrecognized depletion model "${importedName}" for customer/SKU ${customerKey}.`;
							return;
						}

						const importId = normalizeDepletionModelId(
							matchedImportModel.depletionModelID ??
								matchedImportModel.DepletionModelID
						);
						const gridId = normalizeDepletionModelId(
							item.depletionModelID ?? item.DepletionModelID
						);

						if (importId !== gridId) {
							state.isError = true;
							state.isError_Info = `Depletion model mismatch for ${customerKey}: the file lists "${importedName}" but the grid row uses a different depletion model.`;
							return;
						}
					}

					customers.forEach((customer) => {
						const customerKey = `${
							customer.customerNumber !== null
								? customer.customerNumber
								: customer.customerName
						}_${customer.skuNumb}`;
						const item = gridDataMap.get(customerKey);

						if (!item) return;
						let initialQuotaCondition = false;
						if (state.includeZeroMs === true) {
							initialQuotaCondition =
								item.customerPercentageExact <=
								CUSTOMER_PERCENTAGE_THRESHOLD;
						} else {
							initialQuotaCondition =
								item.customerPercentageExact >
								CUSTOMER_PERCENTAGE_THRESHOLD;
						}
						item.initialQuota = initialQuotaCondition
							? Math.max(customer.initialQuota, item.minimumQuota)
							 : customer.initialQuota;

						item.adjustment = customer.adjustment;
						item.tender = customer.tender;
						item.customerQuotaComments = customer.customerQuotaComments;
						item.safetyMargin = customer.safetyMargin;

						const importedName = String(
							customer.depletionModelName ??
								customer.DepletionModelName ??
								""
						).trim();
						let matchedImportModel = null;
						if (importedName && state.depletionModelsList?.length) {
							const low = importedName.toLowerCase();
							matchedImportModel = state.depletionModelsList.find(
								(x) =>
									String(
										x.depletionModelName ??
											x.DepletionModelName ??
											""
									)
										.trim()
										.toLowerCase() === low
							);
							if (matchedImportModel) {
								item.depletionModel =
									matchedImportModel.depletionModel ??
									matchedImportModel.DepletionModel;
								item.depletionModelID =
									matchedImportModel.depletionModelID ??
									matchedImportModel.DepletionModelID ??
									item.depletionModelID;
							}
						}
						const importDepletionKey =
							matchedImportModel != null
								? String(
										matchedImportModel.depletionModel ??
											""
									)
										.trim()
										.toLowerCase()
								: rowDepletionModelKey(item);

						const safetyMargin =
							(item.initialQuota * item.safetyMargin) / 100;
						const updatedQuota = Math.round(
							item.initialQuota +
								safetyMargin +
								item.adjustment +
								item.tender
						);

						if (
							importDepletionKey === "none" ||
							importDepletionKey === ""
						) {
							item.weekly1 = updatedQuota;
							item.weekly2 = 0;
							item.weekly3 = 0;
							item.weekly4 = 0;
							item.weekly5 = 0;
						} else if (importDepletionKey === "biweekly") {
							item.weekly1 = Math.round(customer.weekly1 ?? 0);
							item.weekly2 = updatedQuota;
							item.weekly3 = 0;
							item.weekly4 = 0;
							item.weekly5 = 0;
						} else {
							item.weekly1 = Math.round(customer.weekly1 ?? 0);
							item.weekly2 = Math.round(customer.weekly2 ?? 0);
							item.weekly3 = Math.round(customer.weekly3 ?? 0);
							const importRowWeek4Only =
								rowIsWeek4OnlyForExport(item, state.isWeek4Only);
							item.weekly4 = importRowWeek4Only
								? updatedQuota
								: Math.round(customer.weekly4 ?? 0);
							item.weekly5 = state.isWeek4Only ? 0 : updatedQuota;
						}

						item.quota = updatedQuota;
					});

					state.gridDataFiltered = state.gridData;
					syncPreRounderBackupIfNeeded(state, state.gridData);
					let customersList = prepareCustomers(
						state.gridData,
						state.gridDataFiltered
					);
					let validationResult = validateCustomers(
						customersList,
						"",
						state.isWeek4Only
					);
					if (typeof validationResult === "string") {
						state.isError_Info = validationResult;
						state.isError = true;
					} else {
						state.isSuccess = true;
						state.isSuccess_Info =
							"Customer data imported successfully.";
					}
				} else {
					state.isFailed = true;
					state.isFailed_Info =
						"No Scenario's available for the selected country";
				}
			})
			.addCase(ImportExcel.rejected, (state, action) => {
				state.isLoading = false;
				console.log("Error from ImportExcel", action.error.message);
			})

			.addCase(SaveQuota.pending, (state, action) => {
				state.isLoading = true;
			})
			.addCase(SaveQuota.fulfilled, (state, { payload }) => {
				state.isLoading = false;
				if (typeof payload !== "string") {
					state.isSuccess = true;
					state.isSuccess_Info = "Quota saved successfully";
					const savedRounderDetails = {
						rounder: state.selectedQuota?.rounder,
						rounderTypeID: state.selectedQuota?.rounderTypeID,
						skuRounderDetailsList:
							state.selectedQuota?.skuRounderDetailsList ?? [],
					};
					state.selectedQuota = payload;
					syncLoadedRounderSnapshotFromQuota(
						state,
						mergeRounderDetailsFromQuota(payload, savedRounderDetails)
					);
					clearAppliedRounderState(state);
				} else if (typeof payload === "string") {
					state.isFailed_Info = payload;
					state.isFailed = true;
				} else {
					state.isFailed_Info = "Error occured in save quota";
					state.isFailed = true;
				}
				state.gridDataChanged = false;
			})
			.addCase(SaveQuota.rejected, (state, action) => {
				state.isLoading = false;
				state.isError = true;
				state.isError_Info = "Error occured in save quota";
				console.log("Error from SaveQuota", action.error.message);
			})

			.addCase(SubmitQuota.pending, (state, action) => {
				state.isLoading = true;
			})
			.addCase(SubmitQuota.fulfilled, (state, { payload }) => {
				
				state.isLoading = false;
				// if (typeof payload === "number") {
				// 	state.isSuccess = true;
				// 	state.isSuccess_Info = "Quota submitted successfully";
				// } 
				if(typeof payload ==='object' && payload !== null && 'quotaID' in payload) {
					state.isSuccess = true;
					state.isSuccess_Info = "Quota submitted successfully";
					state.selectedQuota.quotaStatus = payload.quotaStatus;
					state.selectedQuota.quotaID = payload.quotaID;
					syncLoadedRounderSnapshotFromQuota(state, state.selectedQuota);
					clearAppliedRounderState(state);
				}
				else if (typeof payload === "string") {
					state.isFailed_Info = payload;
					state.isFailed = true;
				} else {
					state.isFailed = true;
					state.isFailed_Info = "Error occured in submit quota";
				}
				state.gridDataChanged = false;
			})
			.addCase(SubmitQuota.rejected, (state, action) => {
				state.isLoading = false;
				state.isError = true;
				state.isError_Info = "Error occured in submit quota";
				console.log("Error from SubmitQuota", action.error.message);
			})

			.addCase(Upload.pending, (state, action) => {
				state.isLoading = true;
			})
			.addCase(Upload.fulfilled, (state, { payload }) => {
				state.isLoading = false;
				state.filepath = payload.map((x) => x.filePath);
				state.files = [];
			})
			.addCase(Upload.rejected, (state, action) => {
				state.isLoading = false;
			})

			.addCase(exportFile.pending, (state, action) => {
				state.isLoading = true;
			})
			.addCase(exportFile.fulfilled, (state, { payload }) => {
				state.isLoading = false;
			})
			.addCase(exportFile.rejected, (state, action) => {
				state.isLoading = false;
				console.log("Error from exportFile", action.error.message);
			});
	},
});

export const {
	// setCountries,
	setState,
	setSelectedCountry,
	setSelectedScenario,
	setSelectedPeriod,
	setForecast,
	setQuotaCopy,
	setTimeDepletion,
	setDepletionPeriodType,
	setSelectProduct,
	setRounder,
	setSelectedRounderTypeID,
	setOverBoxRoundValue,
	setSafetyMargin,
	setBufferAdjustment,
	setApplyRounder,
	setApplyOverBoxRounder,
	SetCustomerQuotaValues,
	setApplySafetyMargin,
	setApplyBufferAdjustment,
	setTotalValues,
	setWeekPercent,
	setWeekPercentDepletion,
	setLoadData,
	clearStatus,
	setCustomerQuotaWeekValues,
	setQuotaObject,
	reset,
	navigatedValues,
	addFile,
	deleteFile,
	deleteExistingFile,
} = defineSlice.actions;

export default defineSlice.reducer;
